import { ref as De, reactive as ct, defineComponent as Fo, computed as Tt, onMounted as Ro, createElementBlock as ae, openBlock as ie, createElementVNode as B, createCommentVNode as Te, createStaticVNode as Wo, toDisplayString as ne, withDirectives as st, vModelText as rt, unref as Y, Fragment as Ot, renderList as Dt, withKeys as Zo } from "vue";
var ht = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function pt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Rt = { exports: {} };
(function(e, t) {
  (function(o, n) {
    e.exports = n();
  })(ht, function() {
    var o = 1e3, n = 6e4, s = 36e5, a = "millisecond", w = "second", m = "minute", u = "hour", k = "day", S = "week", $ = "month", T = "quarter", A = "year", b = "date", d = "Invalid Date", E = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, H = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(f) {
      var c = ["th", "st", "nd", "rd"], i = f % 100;
      return "[" + f + (c[(i - 20) % 10] || c[i] || c[0]) + "]";
    } }, g = function(f, c, i) {
      var p = String(f);
      return !p || p.length >= c ? f : "" + Array(c + 1 - p.length).join(i) + f;
    }, x = { s: g, z: function(f) {
      var c = -f.utcOffset(), i = Math.abs(c), p = Math.floor(i / 60), l = i % 60;
      return (c <= 0 ? "+" : "-") + g(p, 2, "0") + ":" + g(l, 2, "0");
    }, m: function f(c, i) {
      if (c.date() < i.date()) return -f(i, c);
      var p = 12 * (i.year() - c.year()) + (i.month() - c.month()), l = c.clone().add(p, $), v = i - l < 0, y = c.clone().add(p + (v ? -1 : 1), $);
      return +(-(p + (i - l) / (v ? l - y : y - l)) || 0);
    }, a: function(f) {
      return f < 0 ? Math.ceil(f) || 0 : Math.floor(f);
    }, p: function(f) {
      return { M: $, y: A, w: S, d: k, D: b, h: u, m, s: w, ms: a, Q: T }[f] || String(f || "").toLowerCase().replace(/s$/, "");
    }, u: function(f) {
      return f === void 0;
    } }, z = "en", j = {};
    j[z] = M;
    var J = "$isDayjsObject", re = function(f) {
      return f instanceof qe || !(!f || !f[J]);
    }, Q = function f(c, i, p) {
      var l;
      if (!c) return z;
      if (typeof c == "string") {
        var v = c.toLowerCase();
        j[v] && (l = v), i && (j[v] = i, l = v);
        var y = c.split("-");
        if (!l && y.length > 1) return f(y[0]);
      } else {
        var O = c.name;
        j[O] = c, l = O;
      }
      return !p && l && (z = l), l || !p && z;
    }, _ = function(f, c) {
      if (re(f)) return f.clone();
      var i = typeof c == "object" ? c : {};
      return i.date = f, i.args = arguments, new qe(i);
    }, C = x;
    C.l = Q, C.i = re, C.w = function(f, c) {
      return _(f, { locale: c.$L, utc: c.$u, x: c.$x, $offset: c.$offset });
    };
    var qe = function() {
      function f(i) {
        this.$L = Q(i.locale, null, !0), this.parse(i), this.$x = this.$x || i.x || {}, this[J] = !0;
      }
      var c = f.prototype;
      return c.parse = function(i) {
        this.$d = function(p) {
          var l = p.date, v = p.utc;
          if (l === null) return /* @__PURE__ */ new Date(NaN);
          if (C.u(l)) return /* @__PURE__ */ new Date();
          if (l instanceof Date) return new Date(l);
          if (typeof l == "string" && !/Z$/i.test(l)) {
            var y = l.match(E);
            if (y) {
              var O = y[2] - 1 || 0, I = (y[7] || "0").substring(0, 3);
              return v ? new Date(Date.UTC(y[1], O, y[3] || 1, y[4] || 0, y[5] || 0, y[6] || 0, I)) : new Date(y[1], O, y[3] || 1, y[4] || 0, y[5] || 0, y[6] || 0, I);
            }
          }
          return new Date(l);
        }(i), this.init();
      }, c.init = function() {
        var i = this.$d;
        this.$y = i.getFullYear(), this.$M = i.getMonth(), this.$D = i.getDate(), this.$W = i.getDay(), this.$H = i.getHours(), this.$m = i.getMinutes(), this.$s = i.getSeconds(), this.$ms = i.getMilliseconds();
      }, c.$utils = function() {
        return C;
      }, c.isValid = function() {
        return this.$d.toString() !== d;
      }, c.isSame = function(i, p) {
        var l = _(i);
        return this.startOf(p) <= l && l <= this.endOf(p);
      }, c.isAfter = function(i, p) {
        return _(i) < this.startOf(p);
      }, c.isBefore = function(i, p) {
        return this.endOf(p) < _(i);
      }, c.$g = function(i, p, l) {
        return C.u(i) ? this[p] : this.set(l, i);
      }, c.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, c.valueOf = function() {
        return this.$d.getTime();
      }, c.startOf = function(i, p) {
        var l = this, v = !!C.u(p) || p, y = C.p(i), O = function(ge, K) {
          var de = C.w(l.$u ? Date.UTC(l.$y, K, ge) : new Date(l.$y, K, ge), l);
          return v ? de : de.endOf(k);
        }, I = function(ge, K) {
          return C.w(l.toDate()[ge].apply(l.toDate("s"), (v ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(K)), l);
        }, N = this.$W, F = this.$M, oe = this.$D, ke = "set" + (this.$u ? "UTC" : "");
        switch (y) {
          case A:
            return v ? O(1, 0) : O(31, 11);
          case $:
            return v ? O(1, F) : O(0, F + 1);
          case S:
            var pe = this.$locale().weekStart || 0, Me = (N < pe ? N + 7 : N) - pe;
            return O(v ? oe - Me : oe + (6 - Me), F);
          case k:
          case b:
            return I(ke + "Hours", 0);
          case u:
            return I(ke + "Minutes", 1);
          case m:
            return I(ke + "Seconds", 2);
          case w:
            return I(ke + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, c.endOf = function(i) {
        return this.startOf(i, !1);
      }, c.$set = function(i, p) {
        var l, v = C.p(i), y = "set" + (this.$u ? "UTC" : ""), O = (l = {}, l[k] = y + "Date", l[b] = y + "Date", l[$] = y + "Month", l[A] = y + "FullYear", l[u] = y + "Hours", l[m] = y + "Minutes", l[w] = y + "Seconds", l[a] = y + "Milliseconds", l)[v], I = v === k ? this.$D + (p - this.$W) : p;
        if (v === $ || v === A) {
          var N = this.clone().set(b, 1);
          N.$d[O](I), N.init(), this.$d = N.set(b, Math.min(this.$D, N.daysInMonth())).$d;
        } else O && this.$d[O](I);
        return this.init(), this;
      }, c.set = function(i, p) {
        return this.clone().$set(i, p);
      }, c.get = function(i) {
        return this[C.p(i)]();
      }, c.add = function(i, p) {
        var l, v = this;
        i = Number(i);
        var y = C.p(p), O = function(F) {
          var oe = _(v);
          return C.w(oe.date(oe.date() + Math.round(F * i)), v);
        };
        if (y === $) return this.set($, this.$M + i);
        if (y === A) return this.set(A, this.$y + i);
        if (y === k) return O(1);
        if (y === S) return O(7);
        var I = (l = {}, l[m] = n, l[u] = s, l[w] = o, l)[y] || 1, N = this.$d.getTime() + i * I;
        return C.w(N, this);
      }, c.subtract = function(i, p) {
        return this.add(-1 * i, p);
      }, c.format = function(i) {
        var p = this, l = this.$locale();
        if (!this.isValid()) return l.invalidDate || d;
        var v = i || "YYYY-MM-DDTHH:mm:ssZ", y = C.z(this), O = this.$H, I = this.$m, N = this.$M, F = l.weekdays, oe = l.months, ke = l.meridiem, pe = function(K, de, Be, Ne) {
          return K && (K[de] || K(p, v)) || Be[de].slice(0, Ne);
        }, Me = function(K) {
          return C.s(O % 12 || 12, K, "0");
        }, ge = ke || function(K, de, Be) {
          var Ne = K < 12 ? "AM" : "PM";
          return Be ? Ne.toLowerCase() : Ne;
        };
        return v.replace(H, function(K, de) {
          return de || function(Be) {
            switch (Be) {
              case "YY":
                return String(p.$y).slice(-2);
              case "YYYY":
                return C.s(p.$y, 4, "0");
              case "M":
                return N + 1;
              case "MM":
                return C.s(N + 1, 2, "0");
              case "MMM":
                return pe(l.monthsShort, N, oe, 3);
              case "MMMM":
                return pe(oe, N);
              case "D":
                return p.$D;
              case "DD":
                return C.s(p.$D, 2, "0");
              case "d":
                return String(p.$W);
              case "dd":
                return pe(l.weekdaysMin, p.$W, F, 2);
              case "ddd":
                return pe(l.weekdaysShort, p.$W, F, 3);
              case "dddd":
                return F[p.$W];
              case "H":
                return String(O);
              case "HH":
                return C.s(O, 2, "0");
              case "h":
                return Me(1);
              case "hh":
                return Me(2);
              case "a":
                return ge(O, I, !0);
              case "A":
                return ge(O, I, !1);
              case "m":
                return String(I);
              case "mm":
                return C.s(I, 2, "0");
              case "s":
                return String(p.$s);
              case "ss":
                return C.s(p.$s, 2, "0");
              case "SSS":
                return C.s(p.$ms, 3, "0");
              case "Z":
                return y;
            }
            return null;
          }(K) || y.replace(":", "");
        });
      }, c.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, c.diff = function(i, p, l) {
        var v, y = this, O = C.p(p), I = _(i), N = (I.utcOffset() - this.utcOffset()) * n, F = this - I, oe = function() {
          return C.m(y, I);
        };
        switch (O) {
          case A:
            v = oe() / 12;
            break;
          case $:
            v = oe();
            break;
          case T:
            v = oe() / 3;
            break;
          case S:
            v = (F - N) / 6048e5;
            break;
          case k:
            v = (F - N) / 864e5;
            break;
          case u:
            v = F / s;
            break;
          case m:
            v = F / n;
            break;
          case w:
            v = F / o;
            break;
          default:
            v = F;
        }
        return l ? v : C.a(v);
      }, c.daysInMonth = function() {
        return this.endOf($).$D;
      }, c.$locale = function() {
        return j[this.$L];
      }, c.locale = function(i, p) {
        if (!i) return this.$L;
        var l = this.clone(), v = Q(i, p, !0);
        return v && (l.$L = v), l;
      }, c.clone = function() {
        return C.w(this.$d, this);
      }, c.toDate = function() {
        return new Date(this.valueOf());
      }, c.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, c.toISOString = function() {
        return this.$d.toISOString();
      }, c.toString = function() {
        return this.$d.toUTCString();
      }, f;
    }(), Bt = qe.prototype;
    return _.prototype = Bt, [["$ms", a], ["$s", w], ["$m", m], ["$H", u], ["$W", k], ["$M", $], ["$y", A], ["$D", b]].forEach(function(f) {
      Bt[f[1]] = function(c) {
        return this.$g(c, f[0], f[1]);
      };
    }), _.extend = function(f, c) {
      return f.$i || (f(c, qe, _), f.$i = !0), _;
    }, _.locale = Q, _.isDayjs = re, _.unix = function(f) {
      return _(1e3 * f);
    }, _.en = j[z], _.Ls = j, _.p = {}, _;
  });
})(Rt);
var Ko = Rt.exports;
const Wt = /* @__PURE__ */ pt(Ko);
var Zt = { exports: {} };
(function(e, t) {
  (function(o, n) {
    e.exports = n();
  })(ht, function() {
    var o = "minute", n = /[+-]\d\d(?::?\d\d)?/g, s = /([+-]|\d\d)/g;
    return function(a, w, m) {
      var u = w.prototype;
      m.utc = function(d) {
        var E = { date: d, utc: !0, args: arguments };
        return new w(E);
      }, u.utc = function(d) {
        var E = m(this.toDate(), { locale: this.$L, utc: !0 });
        return d ? E.add(this.utcOffset(), o) : E;
      }, u.local = function() {
        return m(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var k = u.parse;
      u.parse = function(d) {
        d.utc && (this.$u = !0), this.$utils().u(d.$offset) || (this.$offset = d.$offset), k.call(this, d);
      };
      var S = u.init;
      u.init = function() {
        if (this.$u) {
          var d = this.$d;
          this.$y = d.getUTCFullYear(), this.$M = d.getUTCMonth(), this.$D = d.getUTCDate(), this.$W = d.getUTCDay(), this.$H = d.getUTCHours(), this.$m = d.getUTCMinutes(), this.$s = d.getUTCSeconds(), this.$ms = d.getUTCMilliseconds();
        } else S.call(this);
      };
      var $ = u.utcOffset;
      u.utcOffset = function(d, E) {
        var H = this.$utils().u;
        if (H(d)) return this.$u ? 0 : H(this.$offset) ? $.call(this) : this.$offset;
        if (typeof d == "string" && (d = function(z) {
          z === void 0 && (z = "");
          var j = z.match(n);
          if (!j) return null;
          var J = ("" + j[0]).match(s) || ["-", 0, 0], re = J[0], Q = 60 * +J[1] + +J[2];
          return Q === 0 ? 0 : re === "+" ? Q : -Q;
        }(d), d === null)) return this;
        var M = Math.abs(d) <= 16 ? 60 * d : d;
        if (M === 0) return this.utc(E);
        var g = this.clone();
        if (E) return g.$offset = M, g.$u = !1, g;
        var x = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
        return (g = this.local().add(M + x, o)).$offset = M, g.$x.$localOffset = x, g;
      };
      var T = u.format;
      u.format = function(d) {
        var E = d || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return T.call(this, E);
      }, u.valueOf = function() {
        var d = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * d;
      }, u.isUTC = function() {
        return !!this.$u;
      }, u.toISOString = function() {
        return this.toDate().toISOString();
      }, u.toString = function() {
        return this.toDate().toUTCString();
      };
      var A = u.toDate;
      u.toDate = function(d) {
        return d === "s" && this.$offset ? m(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : A.call(this);
      };
      var b = u.diff;
      u.diff = function(d, E, H) {
        if (d && this.$u === d.$u) return b.call(this, d, E, H);
        var M = this.local(), g = m(d).local();
        return b.call(M, g, E, H);
      };
    };
  });
})(Zt);
var Xo = Zt.exports;
const Jo = /* @__PURE__ */ pt(Xo);
var Kt = { exports: {} };
(function(e, t) {
  (function(o, n) {
    e.exports = n();
  })(ht, function() {
    var o = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, n = {};
    return function(s, a, w) {
      var m, u = function(T, A, b) {
        b === void 0 && (b = {});
        var d = new Date(T), E = function(H, M) {
          M === void 0 && (M = {});
          var g = M.timeZoneName || "short", x = H + "|" + g, z = n[x];
          return z || (z = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: H, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: g }), n[x] = z), z;
        }(A, b);
        return E.formatToParts(d);
      }, k = function(T, A) {
        for (var b = u(T, A), d = [], E = 0; E < b.length; E += 1) {
          var H = b[E], M = H.type, g = H.value, x = o[M];
          x >= 0 && (d[x] = parseInt(g, 10));
        }
        var z = d[3], j = z === 24 ? 0 : z, J = d[0] + "-" + d[1] + "-" + d[2] + " " + j + ":" + d[4] + ":" + d[5] + ":000", re = +T;
        return (w.utc(J).valueOf() - (re -= re % 1e3)) / 6e4;
      }, S = a.prototype;
      S.tz = function(T, A) {
        T === void 0 && (T = m);
        var b, d = this.utcOffset(), E = this.toDate(), H = E.toLocaleString("en-US", { timeZone: T }), M = Math.round((E - new Date(H)) / 1e3 / 60), g = 15 * -Math.round(E.getTimezoneOffset() / 15) - M;
        if (!Number(g)) b = this.utcOffset(0, A);
        else if (b = w(H, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(g, !0), A) {
          var x = b.utcOffset();
          b = b.add(d - x, "minute");
        }
        return b.$x.$timezone = T, b;
      }, S.offsetName = function(T) {
        var A = this.$x.$timezone || w.tz.guess(), b = u(this.valueOf(), A, { timeZoneName: T }).find(function(d) {
          return d.type.toLowerCase() === "timezonename";
        });
        return b && b.value;
      };
      var $ = S.startOf;
      S.startOf = function(T, A) {
        if (!this.$x || !this.$x.$timezone) return $.call(this, T, A);
        var b = w(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
        return $.call(b, T, A).tz(this.$x.$timezone, !0);
      }, w.tz = function(T, A, b) {
        var d = b && A, E = b || A || m, H = k(+w(), E);
        if (typeof T != "string") return w(T).tz(E);
        var M = function(j, J, re) {
          var Q = j - 60 * J * 1e3, _ = k(Q, re);
          if (J === _) return [Q, J];
          var C = k(Q -= 60 * (_ - J) * 1e3, re);
          return _ === C ? [Q, _] : [j - 60 * Math.min(_, C) * 1e3, Math.max(_, C)];
        }(w.utc(T, d).valueOf(), H, E), g = M[0], x = M[1], z = w(g).utcOffset(x);
        return z.$x.$timezone = E, z;
      }, w.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, w.tz.setDefault = function(T) {
        m = T;
      };
    };
  });
})(Kt);
var Qo = Kt.exports;
const Go = /* @__PURE__ */ pt(Qo);
Wt.extend(Jo);
Wt.extend(Go);
/*!
* sweetalert2 v11.26.17
* Released under the MIT License.
*/
function Xt(e, t, o) {
  if (typeof e == "function" ? e === t : e.has(t)) return arguments.length < 3 ? t : o;
  throw new TypeError("Private element is not present on this object");
}
function en(e, t) {
  if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function _t(e, t) {
  return e.get(Xt(e, t));
}
function tn(e, t, o) {
  en(e, t), t.set(e, o);
}
function on(e, t, o) {
  return e.set(Xt(e, t), o), o;
}
const nn = 100, h = {}, sn = () => {
  h.previousActiveElement instanceof HTMLElement ? (h.previousActiveElement.focus(), h.previousActiveElement = null) : document.body && document.body.focus();
}, rn = (e) => new Promise((t) => {
  if (!e)
    return t();
  const o = window.scrollX, n = window.scrollY;
  h.restoreFocusTimeout = setTimeout(() => {
    sn(), t();
  }, nn), window.scrollTo(o, n);
}), Jt = "swal2-", an = ["container", "shown", "height-auto", "iosfix", "popup", "modal", "no-backdrop", "no-transition", "toast", "toast-shown", "show", "hide", "close", "title", "html-container", "actions", "confirm", "deny", "cancel", "footer", "icon", "icon-content", "image", "input", "file", "range", "select", "radio", "checkbox", "label", "textarea", "inputerror", "input-label", "validation-message", "progress-steps", "active-progress-step", "progress-step", "progress-step-line", "loader", "loading", "styled", "top", "top-start", "top-end", "top-left", "top-right", "center", "center-start", "center-end", "center-left", "center-right", "bottom", "bottom-start", "bottom-end", "bottom-left", "bottom-right", "grow-row", "grow-column", "grow-fullscreen", "rtl", "timer-progress-bar", "timer-progress-bar-container", "scrollbar-measure", "icon-success", "icon-warning", "icon-info", "icon-question", "icon-error", "draggable", "dragging"], r = an.reduce(
  (e, t) => (e[t] = Jt + t, e),
  /** @type {SwalClasses} */
  {}
), ln = ["success", "warning", "info", "question", "error"], Ue = ln.reduce(
  (e, t) => (e[t] = Jt + t, e),
  /** @type {SwalIcons} */
  {}
), Qt = "SweetAlert2:", gt = (e) => e.charAt(0).toUpperCase() + e.slice(1), W = (e) => {
  console.warn(`${Qt} ${typeof e == "object" ? e.join(" ") : e}`);
}, ye = (e) => {
  console.error(`${Qt} ${e}`);
}, zt = [], cn = (e) => {
  zt.includes(e) || (zt.push(e), W(e));
}, Gt = (e, t = null) => {
  cn(`"${e}" is deprecated and will be removed in the next major release.${t ? ` Use "${t}" instead.` : ""}`);
}, Ge = (e) => typeof e == "function" ? e() : e, ft = (e) => e && typeof e.toPromise == "function", _e = (e) => ft(e) ? e.toPromise() : Promise.resolve(e), bt = (e) => e && Promise.resolve(e) === e, Z = () => document.body.querySelector(`.${r.container}`), ze = (e) => {
  const t = Z();
  return t ? t.querySelector(e) : null;
}, ee = (e) => ze(`.${e}`), L = () => ee(r.popup), Ee = () => ee(r.icon), un = () => ee(r["icon-content"]), eo = () => ee(r.title), vt = () => ee(r["html-container"]), to = () => ee(r.image), yt = () => ee(r["progress-steps"]), et = () => ee(r["validation-message"]), ce = () => (
  /** @type {HTMLButtonElement} */
  ze(`.${r.actions} .${r.confirm}`)
), Pe = () => (
  /** @type {HTMLButtonElement} */
  ze(`.${r.actions} .${r.cancel}`)
), xe = () => (
  /** @type {HTMLButtonElement} */
  ze(`.${r.actions} .${r.deny}`)
), dn = () => ee(r["input-label"]), Le = () => ze(`.${r.loader}`), je = () => ee(r.actions), oo = () => ee(r.footer), tt = () => ee(r["timer-progress-bar"]), xt = () => ee(r.close), wn = `
  a[href],
  area[href],
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  button:not([disabled]),
  iframe,
  object,
  embed,
  [tabindex="0"],
  [contenteditable],
  audio[controls],
  video[controls],
  summary
`, kt = () => {
  const e = L();
  if (!e)
    return [];
  const t = e.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'), o = Array.from(t).sort((a, w) => {
    const m = parseInt(a.getAttribute("tabindex") || "0"), u = parseInt(w.getAttribute("tabindex") || "0");
    return m > u ? 1 : m < u ? -1 : 0;
  }), n = e.querySelectorAll(wn), s = Array.from(n).filter((a) => a.getAttribute("tabindex") !== "-1");
  return [...new Set(o.concat(s))].filter((a) => X(a));
}, $t = () => ue(document.body, r.shown) && !ue(document.body, r["toast-shown"]) && !ue(document.body, r["no-backdrop"]), ot = () => {
  const e = L();
  return e ? ue(e, r.toast) : !1;
}, mn = () => {
  const e = L();
  return e ? e.hasAttribute("data-loading") : !1;
}, te = (e, t) => {
  if (e.textContent = "", t) {
    const o = new DOMParser().parseFromString(t, "text/html"), n = o.querySelector("head");
    n && Array.from(n.childNodes).forEach((a) => {
      e.appendChild(a);
    });
    const s = o.querySelector("body");
    s && Array.from(s.childNodes).forEach((a) => {
      a instanceof HTMLVideoElement || a instanceof HTMLAudioElement ? e.appendChild(a.cloneNode(!0)) : e.appendChild(a);
    });
  }
}, ue = (e, t) => {
  if (!t)
    return !1;
  const o = t.split(/\s+/);
  for (let n = 0; n < o.length; n++)
    if (!e.classList.contains(o[n]))
      return !1;
  return !0;
}, hn = (e, t) => {
  Array.from(e.classList).forEach((o) => {
    !Object.values(r).includes(o) && !Object.values(Ue).includes(o) && !Object.values(t.showClass || {}).includes(o) && e.classList.remove(o);
  });
}, G = (e, t, o) => {
  if (hn(e, t), !t.customClass)
    return;
  const n = t.customClass[
    /** @type {keyof SweetAlertCustomClass} */
    o
  ];
  if (n) {
    if (typeof n != "string" && !n.forEach) {
      W(`Invalid type of customClass.${o}! Expected string or iterable object, got "${typeof n}"`);
      return;
    }
    P(e, n);
  }
}, nt = (e, t) => {
  if (!t)
    return null;
  switch (t) {
    case "select":
    case "textarea":
    case "file":
      return e.querySelector(`.${r.popup} > .${r[t]}`);
    case "checkbox":
      return e.querySelector(`.${r.popup} > .${r.checkbox} input`);
    case "radio":
      return e.querySelector(`.${r.popup} > .${r.radio} input:checked`) || e.querySelector(`.${r.popup} > .${r.radio} input:first-child`);
    case "range":
      return e.querySelector(`.${r.popup} > .${r.range} input`);
    default:
      return e.querySelector(`.${r.popup} > .${r.input}`);
  }
}, no = (e) => {
  if (e.focus(), e.type !== "file") {
    const t = e.value;
    e.value = "", e.value = t;
  }
}, so = (e, t, o) => {
  !e || !t || (typeof t == "string" && (t = t.split(/\s+/).filter(Boolean)), t.forEach((n) => {
    Array.isArray(e) ? e.forEach((s) => {
      o ? s.classList.add(n) : s.classList.remove(n);
    }) : o ? e.classList.add(n) : e.classList.remove(n);
  }));
}, P = (e, t) => {
  so(e, t, !0);
}, se = (e, t) => {
  so(e, t, !1);
}, we = (e, t) => {
  const o = Array.from(e.children);
  for (let n = 0; n < o.length; n++) {
    const s = o[n];
    if (s instanceof HTMLElement && ue(s, t))
      return s;
  }
}, be = (e, t, o) => {
  o === `${parseInt(`${o}`)}` && (o = parseInt(o)), o || parseInt(`${o}`) === 0 ? e.style.setProperty(t, typeof o == "number" ? `${o}px` : (
    /** @type {string} */
    o
  )) : e.style.removeProperty(t);
}, U = (e, t = "flex") => {
  e && (e.style.display = t);
}, R = (e) => {
  e && (e.style.display = "none");
}, Ct = (e, t = "block") => {
  e && new MutationObserver(() => {
    He(e, e.innerHTML, t);
  }).observe(e, {
    childList: !0,
    subtree: !0
  });
}, jt = (e, t, o, n) => {
  const s = e.querySelector(t);
  s && s.style.setProperty(o, n);
}, He = (e, t, o = "flex") => {
  t ? U(e, o) : R(e);
}, X = (e) => !!(e && (e.offsetWidth || e.offsetHeight || e.getClientRects().length)), pn = () => !X(ce()) && !X(xe()) && !X(Pe()), ut = (e) => e.scrollHeight > e.clientHeight, gn = (e, t) => {
  let o = (
    /** @type {HTMLElement | null} */
    e
  );
  for (; o && o !== t; ) {
    if (ut(o))
      return !0;
    o = o.parentElement;
  }
  return !1;
}, ro = (e) => {
  const t = window.getComputedStyle(e), o = parseFloat(t.getPropertyValue("animation-duration") || "0"), n = parseFloat(t.getPropertyValue("transition-duration") || "0");
  return o > 0 || n > 0;
}, At = (e, t = !1) => {
  const o = tt();
  o && X(o) && (t && (o.style.transition = "none", o.style.width = "100%"), setTimeout(() => {
    o.style.transition = `width ${e / 1e3}s linear`, o.style.width = "0%";
  }, 10));
}, fn = () => {
  const e = tt();
  if (!e)
    return;
  const t = parseInt(window.getComputedStyle(e).width);
  e.style.removeProperty("transition"), e.style.width = "100%";
  const o = parseInt(window.getComputedStyle(e).width), n = t / o * 100;
  e.style.width = `${n}%`;
}, bn = () => typeof window > "u" || typeof document > "u", vn = `
 <div aria-labelledby="${r.title}" aria-describedby="${r["html-container"]}" class="${r.popup}" tabindex="-1">
   <button type="button" class="${r.close}"></button>
   <ul class="${r["progress-steps"]}"></ul>
   <div class="${r.icon}"></div>
   <img class="${r.image}" />
   <h2 class="${r.title}" id="${r.title}"></h2>
   <div class="${r["html-container"]}" id="${r["html-container"]}"></div>
   <input class="${r.input}" id="${r.input}" />
   <input type="file" class="${r.file}" />
   <div class="${r.range}">
     <input type="range" />
     <output></output>
   </div>
   <select class="${r.select}" id="${r.select}"></select>
   <div class="${r.radio}"></div>
   <label class="${r.checkbox}">
     <input type="checkbox" id="${r.checkbox}" />
     <span class="${r.label}"></span>
   </label>
   <textarea class="${r.textarea}" id="${r.textarea}"></textarea>
   <div class="${r["validation-message"]}" id="${r["validation-message"]}"></div>
   <div class="${r.actions}">
     <div class="${r.loader}"></div>
     <button type="button" class="${r.confirm}"></button>
     <button type="button" class="${r.deny}"></button>
     <button type="button" class="${r.cancel}"></button>
   </div>
   <div class="${r.footer}"></div>
   <div class="${r["timer-progress-bar-container"]}">
     <div class="${r["timer-progress-bar"]}"></div>
   </div>
 </div>
`.replace(/(^|\n)\s*/g, ""), yn = () => {
  const e = Z();
  return e ? (e.remove(), se([document.documentElement, document.body], [
    r["no-backdrop"],
    r["toast-shown"],
    // @ts-ignore: 'has-column' is not defined in swalClasses but may be set dynamically
    r["has-column"]
  ]), !0) : !1;
}, fe = () => {
  h.currentInstance && h.currentInstance.resetValidationMessage();
}, xn = () => {
  const e = L();
  if (!e)
    return;
  const t = we(e, r.input), o = we(e, r.file), n = e.querySelector(`.${r.range} input`), s = e.querySelector(`.${r.range} output`), a = we(e, r.select), w = e.querySelector(`.${r.checkbox} input`), m = we(e, r.textarea);
  t && (t.oninput = fe), o && (o.onchange = fe), a && (a.onchange = fe), w && (w.onchange = fe), m && (m.oninput = fe), n && s && (n.oninput = () => {
    fe(), s.value = n.value;
  }, n.onchange = () => {
    fe(), s.value = n.value;
  });
}, kn = (e) => {
  if (typeof e == "string") {
    const t = document.querySelector(e);
    if (!t)
      throw new Error(`Target element "${e}" not found`);
    return (
      /** @type {HTMLElement} */
      t
    );
  }
  return e;
}, $n = (e) => {
  const t = L();
  t && (t.setAttribute("role", e.toast ? "alert" : "dialog"), t.setAttribute("aria-live", e.toast ? "polite" : "assertive"), e.toast || t.setAttribute("aria-modal", "true"));
}, Cn = (e) => {
  window.getComputedStyle(e).direction === "rtl" && (P(Z(), r.rtl), h.isRTL = !0);
}, An = (e) => {
  const t = yn();
  if (bn()) {
    ye("SweetAlert2 requires document to initialize");
    return;
  }
  const o = document.createElement("div");
  o.className = r.container, t && P(o, r["no-transition"]), te(o, vn), o.dataset.swal2Theme = e.theme;
  const n = kn(e.target || "body");
  n.appendChild(o), e.topLayer && (o.setAttribute("popover", ""), o.showPopover()), $n(e), Cn(n), xn();
}, Et = (e, t) => {
  e instanceof HTMLElement ? t.appendChild(e) : typeof e == "object" ? En(e, t) : e && te(t, e);
}, En = (e, t) => {
  "jquery" in e ? Pn(t, e) : te(t, e.toString());
}, Pn = (e, t) => {
  if (e.textContent = "", 0 in t)
    for (let o = 0; o in t; o++)
      e.appendChild(t[o].cloneNode(!0));
  else
    e.appendChild(t.cloneNode(!0));
}, Ln = (e, t) => {
  const o = je(), n = Le();
  !o || !n || (!t.showConfirmButton && !t.showDenyButton && !t.showCancelButton ? R(o) : U(o), G(o, t, "actions"), Sn(o, n, t), te(n, t.loaderHtml || ""), G(n, t, "loader"));
};
function Sn(e, t, o) {
  const n = ce(), s = xe(), a = Pe();
  !n || !s || !a || (it(n, "confirm", o), it(s, "deny", o), it(a, "cancel", o), Mn(n, s, a, o), o.reverseButtons && (o.toast ? (e.insertBefore(a, n), e.insertBefore(s, n)) : (e.insertBefore(a, t), e.insertBefore(s, t), e.insertBefore(n, t))));
}
function Mn(e, t, o, n) {
  if (!n.buttonsStyling) {
    se([e, t, o], r.styled);
    return;
  }
  P([e, t, o], r.styled), n.confirmButtonColor && e.style.setProperty("--swal2-confirm-button-background-color", n.confirmButtonColor), n.denyButtonColor && t.style.setProperty("--swal2-deny-button-background-color", n.denyButtonColor), n.cancelButtonColor && o.style.setProperty("--swal2-cancel-button-background-color", n.cancelButtonColor), at(e), at(t), at(o);
}
function at(e) {
  const t = window.getComputedStyle(e);
  if (t.getPropertyValue("--swal2-action-button-focus-box-shadow"))
    return;
  const o = t.backgroundColor.replace(/rgba?\((\d+), (\d+), (\d+).*/, "rgba($1, $2, $3, 0.5)");
  e.style.setProperty("--swal2-action-button-focus-box-shadow", t.getPropertyValue("--swal2-outline").replace(/ rgba\(.*/, ` ${o}`));
}
function it(e, t, o) {
  const n = (
    /** @type {'Confirm' | 'Deny' | 'Cancel'} */
    gt(t)
  );
  He(e, o[`show${n}Button`], "inline-block"), te(e, o[`${t}ButtonText`] || ""), e.setAttribute("aria-label", o[`${t}ButtonAriaLabel`] || ""), e.className = r[t], G(e, o, `${t}Button`);
}
const Bn = (e, t) => {
  const o = xt();
  o && (te(o, t.closeButtonHtml || ""), G(o, t, "closeButton"), He(o, t.showCloseButton), o.setAttribute("aria-label", t.closeButtonAriaLabel || ""));
}, Tn = (e, t) => {
  const o = Z();
  o && (On(o, t.backdrop), Dn(o, t.position), _n(o, t.grow), G(o, t, "container"));
};
function On(e, t) {
  typeof t == "string" ? e.style.background = t : t || P([document.documentElement, document.body], r["no-backdrop"]);
}
function Dn(e, t) {
  t && (t in r ? P(e, r[t]) : (W('The "position" parameter is not valid, defaulting to "center"'), P(e, r.center)));
}
function _n(e, t) {
  t && P(e, r[`grow-${t}`]);
}
var D = {
  innerParams: /* @__PURE__ */ new WeakMap(),
  domCache: /* @__PURE__ */ new WeakMap()
};
const zn = ["input", "file", "range", "select", "radio", "checkbox", "textarea"], jn = (e, t) => {
  const o = L();
  if (!o)
    return;
  const n = D.innerParams.get(e), s = !n || t.input !== n.input;
  zn.forEach((a) => {
    const w = we(o, r[a]);
    w && (Vn(a, t.inputAttributes), w.className = r[a], s && R(w));
  }), t.input && (s && Hn(t), qn(t));
}, Hn = (e) => {
  if (!e.input)
    return;
  if (!V[e.input]) {
    ye(`Unexpected type of input! Expected ${Object.keys(V).join(" | ")}, got "${e.input}"`);
    return;
  }
  const t = ao(e.input);
  if (!t)
    return;
  const o = V[e.input](t, e);
  U(t), e.inputAutoFocus && setTimeout(() => {
    no(o);
  });
}, In = (e) => {
  for (let t = 0; t < e.attributes.length; t++) {
    const o = e.attributes[t].name;
    ["id", "type", "value", "style"].includes(o) || e.removeAttribute(o);
  }
}, Vn = (e, t) => {
  const o = L();
  if (!o)
    return;
  const n = nt(o, e);
  if (n) {
    In(n);
    for (const s in t)
      n.setAttribute(s, t[s]);
  }
}, qn = (e) => {
  if (!e.input)
    return;
  const t = ao(e.input);
  t && G(t, e, "input");
}, Pt = (e, t) => {
  !e.placeholder && t.inputPlaceholder && (e.placeholder = t.inputPlaceholder);
}, Ie = (e, t, o) => {
  if (o.inputLabel) {
    const n = document.createElement("label"), s = r["input-label"];
    n.setAttribute("for", e.id), n.className = s, typeof o.customClass == "object" && P(n, o.customClass.inputLabel), n.innerText = o.inputLabel, t.insertAdjacentElement("beforebegin", n);
  }
}, ao = (e) => {
  const t = L();
  if (t)
    return we(t, r[
      /** @type {SwalClass} */
      e
    ] || r.input);
}, Fe = (e, t) => {
  ["string", "number"].includes(typeof t) ? e.value = `${t}` : bt(t) || W(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof t}"`);
}, V = {};
V.text = V.email = V.password = V.number = V.tel = V.url = V.search = V.date = V["datetime-local"] = V.time = V.week = V.month = /** @type {(input: Input | HTMLElement, params: SweetAlertOptions) => Input} */
(e, t) => {
  const o = (
    /** @type {HTMLInputElement} */
    e
  );
  return Fe(o, t.inputValue), Ie(o, o, t), Pt(o, t), o.type = /** @type {string} */
  t.input, o;
};
V.file = (e, t) => {
  const o = (
    /** @type {HTMLInputElement} */
    e
  );
  return Ie(o, o, t), Pt(o, t), o;
};
V.range = (e, t) => {
  const o = (
    /** @type {HTMLElement} */
    e
  ), n = o.querySelector("input"), s = o.querySelector("output");
  return n && (Fe(n, t.inputValue), n.type = /** @type {string} */
  t.input, Ie(
    n,
    /** @type {Input} */
    e,
    t
  )), s && Fe(s, t.inputValue), /** @type {Input} */
  e;
};
V.select = (e, t) => {
  const o = (
    /** @type {HTMLSelectElement} */
    e
  );
  if (o.textContent = "", t.inputPlaceholder) {
    const n = document.createElement("option");
    te(n, t.inputPlaceholder), n.value = "", n.disabled = !0, n.selected = !0, o.appendChild(n);
  }
  return Ie(o, o, t), o;
};
V.radio = (e) => {
  const t = (
    /** @type {HTMLElement} */
    e
  );
  return t.textContent = "", /** @type {Input} */
  e;
};
V.checkbox = (e, t) => {
  const o = L();
  if (!o)
    throw new Error("Popup not found");
  const n = nt(o, "checkbox");
  if (!n)
    throw new Error("Checkbox input not found");
  n.value = "1", n.checked = !!t.inputValue;
  const s = (
    /** @type {HTMLElement} */
    e.querySelector("span")
  );
  if (s) {
    const a = t.inputPlaceholder || t.inputLabel;
    a && te(s, a);
  }
  return n;
};
V.textarea = (e, t) => {
  const o = (
    /** @type {HTMLTextAreaElement} */
    e
  );
  Fe(o, t.inputValue), Pt(o, t), Ie(o, o, t);
  const n = (s) => parseInt(window.getComputedStyle(s).marginLeft) + parseInt(window.getComputedStyle(s).marginRight);
  return setTimeout(() => {
    if ("MutationObserver" in window) {
      const s = L();
      if (!s)
        return;
      const a = parseInt(window.getComputedStyle(s).width), w = () => {
        if (!document.body.contains(o))
          return;
        const m = o.offsetWidth + n(o), u = L();
        u && (m > a ? u.style.width = `${m}px` : be(u, "width", t.width));
      };
      new MutationObserver(w).observe(o, {
        attributes: !0,
        attributeFilter: ["style"]
      });
    }
  }), o;
};
const Nn = (e, t) => {
  const o = vt();
  o && (Ct(o), G(o, t, "htmlContainer"), t.html ? (Et(t.html, o), U(o, "block")) : t.text ? (o.textContent = t.text, U(o, "block")) : R(o), jn(e, t));
}, Yn = (e, t) => {
  const o = oo();
  o && (Ct(o), He(o, !!t.footer, "block"), t.footer && Et(t.footer, o), G(o, t, "footer"));
}, Un = (e, t) => {
  const o = D.innerParams.get(e), n = Ee();
  if (n) {
    if (o && t.icon === o.icon) {
      It(n, t), Ht(n, t);
      return;
    }
    if (!t.icon && !t.iconHtml) {
      R(n);
      return;
    }
    if (t.icon && Object.keys(Ue).indexOf(t.icon) === -1) {
      ye(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${t.icon}"`), R(n);
      return;
    }
    U(n), It(n, t), Ht(n, t), P(n, t.showClass && t.showClass.icon), window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", io);
  }
}, Ht = (e, t) => {
  for (const [o, n] of Object.entries(Ue))
    t.icon !== o && se(e, n);
  P(e, t.icon && Ue[t.icon]), Wn(e, t), io(), G(e, t, "icon");
}, io = () => {
  const e = L();
  if (!e)
    return;
  const t = window.getComputedStyle(e).getPropertyValue("background-color"), o = e.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix");
  for (let n = 0; n < o.length; n++)
    o[n].style.backgroundColor = t;
}, Fn = (e) => `
  ${e.animation ? '<div class="swal2-success-circular-line-left"></div>' : ""}
  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
  <div class="swal2-success-ring"></div>
  ${e.animation ? '<div class="swal2-success-fix"></div>' : ""}
  ${e.animation ? '<div class="swal2-success-circular-line-right"></div>' : ""}
`, Rn = `
  <span class="swal2-x-mark">
    <span class="swal2-x-mark-line-left"></span>
    <span class="swal2-x-mark-line-right"></span>
  </span>
`, It = (e, t) => {
  if (!t.icon && !t.iconHtml)
    return;
  let o = e.innerHTML, n = "";
  t.iconHtml ? n = Vt(t.iconHtml) : t.icon === "success" ? (n = Fn(t), o = o.replace(/ style=".*?"/g, "")) : t.icon === "error" ? n = Rn : t.icon && (n = Vt({
    question: "?",
    warning: "!",
    info: "i"
  }[t.icon])), o.trim() !== n.trim() && te(e, n);
}, Wn = (e, t) => {
  if (t.iconColor) {
    e.style.color = t.iconColor, e.style.borderColor = t.iconColor;
    for (const o of [".swal2-success-line-tip", ".swal2-success-line-long", ".swal2-x-mark-line-left", ".swal2-x-mark-line-right"])
      jt(e, o, "background-color", t.iconColor);
    jt(e, ".swal2-success-ring", "border-color", t.iconColor);
  }
}, Vt = (e) => `<div class="${r["icon-content"]}">${e}</div>`, Zn = (e, t) => {
  const o = to();
  if (o) {
    if (!t.imageUrl) {
      R(o);
      return;
    }
    U(o, ""), o.setAttribute("src", t.imageUrl), o.setAttribute("alt", t.imageAlt || ""), be(o, "width", t.imageWidth), be(o, "height", t.imageHeight), o.className = r.image, G(o, t, "image");
  }
};
let Lt = !1, lo = 0, co = 0, uo = 0, wo = 0;
const Kn = (e) => {
  e.addEventListener("mousedown", Re), document.body.addEventListener("mousemove", We), e.addEventListener("mouseup", Ze), e.addEventListener("touchstart", Re), document.body.addEventListener("touchmove", We), e.addEventListener("touchend", Ze);
}, Xn = (e) => {
  e.removeEventListener("mousedown", Re), document.body.removeEventListener("mousemove", We), e.removeEventListener("mouseup", Ze), e.removeEventListener("touchstart", Re), document.body.removeEventListener("touchmove", We), e.removeEventListener("touchend", Ze);
}, Re = (e) => {
  const t = L();
  if (!t)
    return;
  const o = Ee();
  if (e.target === t || o && o.contains(
    /** @type {HTMLElement} */
    e.target
  )) {
    Lt = !0;
    const n = mo(e);
    lo = n.clientX, co = n.clientY, uo = parseInt(t.style.insetInlineStart) || 0, wo = parseInt(t.style.insetBlockStart) || 0, P(t, "swal2-dragging");
  }
}, We = (e) => {
  const t = L();
  if (t && Lt) {
    let {
      clientX: o,
      clientY: n
    } = mo(e);
    const s = o - lo;
    t.style.insetInlineStart = `${uo + (h.isRTL ? -s : s)}px`, t.style.insetBlockStart = `${wo + (n - co)}px`;
  }
}, Ze = () => {
  const e = L();
  Lt = !1, se(e, "swal2-dragging");
}, mo = (e) => {
  let t = 0, o = 0;
  return e.type.startsWith("mouse") ? (t = /** @type {MouseEvent} */
  e.clientX, o = /** @type {MouseEvent} */
  e.clientY) : e.type.startsWith("touch") && (t = /** @type {TouchEvent} */
  e.touches[0].clientX, o = /** @type {TouchEvent} */
  e.touches[0].clientY), {
    clientX: t,
    clientY: o
  };
}, Jn = (e, t) => {
  const o = Z(), n = L();
  if (!(!o || !n)) {
    if (t.toast) {
      be(o, "width", t.width), n.style.width = "100%";
      const s = Le();
      s && n.insertBefore(s, Ee());
    } else
      be(n, "width", t.width);
    be(n, "padding", t.padding), t.color && (n.style.color = t.color), t.background && (n.style.background = t.background), R(et()), Qn(n, t), t.draggable && !t.toast ? (P(n, r.draggable), Kn(n)) : (se(n, r.draggable), Xn(n));
  }
}, Qn = (e, t) => {
  const o = t.showClass || {};
  e.className = `${r.popup} ${X(e) ? o.popup : ""}`, t.toast ? (P([document.documentElement, document.body], r["toast-shown"]), P(e, r.toast)) : P(e, r.modal), G(e, t, "popup"), typeof t.customClass == "string" && P(e, t.customClass), t.icon && P(e, r[`icon-${t.icon}`]);
}, Gn = (e, t) => {
  const o = yt();
  if (!o)
    return;
  const {
    progressSteps: n,
    currentProgressStep: s
  } = t;
  if (!n || n.length === 0 || s === void 0) {
    R(o);
    return;
  }
  U(o), o.textContent = "", s >= n.length && W("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"), n.forEach((a, w) => {
    const m = es(a);
    if (o.appendChild(m), w === s && P(m, r["active-progress-step"]), w !== n.length - 1) {
      const u = ts(t);
      o.appendChild(u);
    }
  });
}, es = (e) => {
  const t = document.createElement("li");
  return P(t, r["progress-step"]), te(t, e), t;
}, ts = (e) => {
  const t = document.createElement("li");
  return P(t, r["progress-step-line"]), e.progressStepsDistance && be(t, "width", e.progressStepsDistance), t;
}, os = (e, t) => {
  const o = eo();
  o && (Ct(o), He(o, !!(t.title || t.titleText), "block"), t.title && Et(t.title, o), t.titleText && (o.innerText = t.titleText), G(o, t, "title"));
}, ho = (e, t) => {
  var o;
  Jn(e, t), Tn(e, t), Gn(e, t), Un(e, t), Zn(e, t), os(e, t), Bn(e, t), Nn(e, t), Ln(e, t), Yn(e, t);
  const n = L();
  typeof t.didRender == "function" && n && t.didRender(n), (o = h.eventEmitter) === null || o === void 0 || o.emit("didRender", n);
}, ns = () => X(L()), po = () => {
  var e;
  return (e = ce()) === null || e === void 0 ? void 0 : e.click();
}, ss = () => {
  var e;
  return (e = xe()) === null || e === void 0 ? void 0 : e.click();
}, rs = () => {
  var e;
  return (e = Pe()) === null || e === void 0 ? void 0 : e.click();
}, Se = Object.freeze({
  cancel: "cancel",
  backdrop: "backdrop",
  close: "close",
  esc: "esc",
  timer: "timer"
}), go = (e) => {
  if (e.keydownTarget && e.keydownHandlerAdded && e.keydownHandler) {
    const t = (
      /** @type {EventListenerOrEventListenerObject} */
      /** @type {unknown} */
      e.keydownHandler
    );
    e.keydownTarget.removeEventListener("keydown", t, {
      capture: e.keydownListenerCapture
    }), e.keydownHandlerAdded = !1;
  }
}, as = (e, t, o) => {
  if (go(e), !t.toast) {
    const n = (a) => ls(t, a, o);
    e.keydownHandler = n;
    const s = t.keydownListenerCapture ? window : L();
    if (s) {
      e.keydownTarget = s, e.keydownListenerCapture = t.keydownListenerCapture;
      const a = (
        /** @type {EventListenerOrEventListenerObject} */
        /** @type {unknown} */
        n
      );
      e.keydownTarget.addEventListener("keydown", a, {
        capture: e.keydownListenerCapture
      }), e.keydownHandlerAdded = !0;
    }
  }
}, dt = (e, t) => {
  var o;
  const n = kt();
  if (n.length) {
    e = e + t, e === -2 && (e = n.length - 1), e === n.length ? e = 0 : e === -1 && (e = n.length - 1), n[e].focus();
    return;
  }
  (o = L()) === null || o === void 0 || o.focus();
}, fo = ["ArrowRight", "ArrowDown"], is = ["ArrowLeft", "ArrowUp"], ls = (e, t, o) => {
  e && (t.isComposing || t.keyCode === 229 || (e.stopKeydownPropagation && t.stopPropagation(), t.key === "Enter" ? cs(t, e) : t.key === "Tab" ? us(t) : [...fo, ...is].includes(t.key) ? ds(t.key) : t.key === "Escape" && ws(t, e, o)));
}, cs = (e, t) => {
  if (!Ge(t.allowEnterKey))
    return;
  const o = L();
  if (!o || !t.input)
    return;
  const n = nt(o, t.input);
  if (e.target && n && e.target instanceof HTMLElement && e.target.outerHTML === n.outerHTML) {
    if (["textarea", "file"].includes(t.input))
      return;
    po(), e.preventDefault();
  }
}, us = (e) => {
  const t = e.target, o = kt();
  let n = -1;
  for (let s = 0; s < o.length; s++)
    if (t === o[s]) {
      n = s;
      break;
    }
  e.shiftKey ? dt(n, -1) : dt(n, 1), e.stopPropagation(), e.preventDefault();
}, ds = (e) => {
  const t = je(), o = ce(), n = xe(), s = Pe();
  if (!t || !o || !n || !s)
    return;
  const a = [o, n, s];
  if (document.activeElement instanceof HTMLElement && !a.includes(document.activeElement))
    return;
  const w = fo.includes(e) ? "nextElementSibling" : "previousElementSibling";
  let m = document.activeElement;
  if (m) {
    for (let u = 0; u < t.children.length; u++) {
      if (m = m[w], !m)
        return;
      if (m instanceof HTMLButtonElement && X(m))
        break;
    }
    m instanceof HTMLButtonElement && m.focus();
  }
}, ws = (e, t, o) => {
  e.preventDefault(), Ge(t.allowEscapeKey) && o(Se.esc);
};
var Ce = {
  swalPromiseResolve: /* @__PURE__ */ new WeakMap(),
  swalPromiseReject: /* @__PURE__ */ new WeakMap()
};
const ms = () => {
  const e = Z();
  Array.from(document.body.children).forEach((t) => {
    t.contains(e) || (t.hasAttribute("aria-hidden") && t.setAttribute("data-previous-aria-hidden", t.getAttribute("aria-hidden") || ""), t.setAttribute("aria-hidden", "true"));
  });
}, bo = () => {
  Array.from(document.body.children).forEach((e) => {
    e.hasAttribute("data-previous-aria-hidden") ? (e.setAttribute("aria-hidden", e.getAttribute("data-previous-aria-hidden") || ""), e.removeAttribute("data-previous-aria-hidden")) : e.removeAttribute("aria-hidden");
  });
}, vo = typeof window < "u" && !!window.GestureEvent, hs = () => {
  if (vo && !ue(document.body, r.iosfix)) {
    const e = document.body.scrollTop;
    document.body.style.top = `${e * -1}px`, P(document.body, r.iosfix), ps();
  }
}, ps = () => {
  const e = Z();
  if (!e)
    return;
  let t;
  e.ontouchstart = (o) => {
    t = gs(o);
  }, e.ontouchmove = (o) => {
    t && (o.preventDefault(), o.stopPropagation());
  };
}, gs = (e) => {
  const t = e.target, o = Z(), n = vt();
  return !o || !n || fs(e) || bs(e) ? !1 : t === o || !ut(o) && t instanceof HTMLElement && !gn(t, n) && // #2823
  t.tagName !== "INPUT" && // #1603
  t.tagName !== "TEXTAREA" && // #2266
  !(ut(n) && // #1944
  n.contains(t));
}, fs = (e) => !!(e.touches && e.touches.length && // @ts-ignore - touchType is not a standard property
e.touches[0].touchType === "stylus"), bs = (e) => e.touches && e.touches.length > 1, vs = () => {
  if (ue(document.body, r.iosfix)) {
    const e = parseInt(document.body.style.top, 10);
    se(document.body, r.iosfix), document.body.style.top = "", document.body.scrollTop = e * -1;
  }
}, ys = () => {
  const e = document.createElement("div");
  e.className = r["scrollbar-measure"], document.body.appendChild(e);
  const t = e.getBoundingClientRect().width - e.clientWidth;
  return document.body.removeChild(e), t;
};
let $e = null;
const xs = (e) => {
  $e === null && (document.body.scrollHeight > window.innerHeight || e === "scroll") && ($e = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right")), document.body.style.paddingRight = `${$e + ys()}px`);
}, ks = () => {
  $e !== null && (document.body.style.paddingRight = `${$e}px`, $e = null);
};
function yo(e, t, o, n) {
  ot() ? qt(e, n) : (rn(o).then(() => qt(e, n)), go(h)), vo ? (t.setAttribute("style", "display:none !important"), t.removeAttribute("class"), t.innerHTML = "") : t.remove(), $t() && (ks(), vs(), bo()), $s();
}
function $s() {
  se([document.documentElement, document.body], [r.shown, r["height-auto"], r["no-backdrop"], r["toast-shown"]]);
}
function me(e) {
  e = As(e);
  const t = Ce.swalPromiseResolve.get(this), o = Cs(this);
  this.isAwaitingPromise ? e.isDismissed || (Ve(this), t(e)) : o && t(e);
}
const Cs = (e) => {
  const t = L();
  if (!t)
    return !1;
  const o = D.innerParams.get(e);
  if (!o || ue(t, o.hideClass.popup))
    return !1;
  se(t, o.showClass.popup), P(t, o.hideClass.popup);
  const n = Z();
  return se(n, o.showClass.backdrop), P(n, o.hideClass.backdrop), Es(e, t, o), !0;
};
function xo(e) {
  const t = Ce.swalPromiseReject.get(this);
  Ve(this), t && t(e);
}
const Ve = (e) => {
  e.isAwaitingPromise && (delete e.isAwaitingPromise, D.innerParams.get(e) || e._destroy());
}, As = (e) => typeof e > "u" ? {
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !0
} : Object.assign({
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !1
}, e), Es = (e, t, o) => {
  var n;
  const s = Z(), a = ro(t);
  typeof o.willClose == "function" && o.willClose(t), (n = h.eventEmitter) === null || n === void 0 || n.emit("willClose", t), a && s ? Ps(e, t, s, !!o.returnFocus, o.didClose) : s && yo(e, s, !!o.returnFocus, o.didClose);
}, Ps = (e, t, o, n, s) => {
  h.swalCloseEventFinishedCallback = yo.bind(null, e, o, n, s);
  const a = function(w) {
    if (w.target === t) {
      var m;
      (m = h.swalCloseEventFinishedCallback) === null || m === void 0 || m.call(h), delete h.swalCloseEventFinishedCallback, t.removeEventListener("animationend", a), t.removeEventListener("transitionend", a);
    }
  };
  t.addEventListener("animationend", a), t.addEventListener("transitionend", a);
}, qt = (e, t) => {
  setTimeout(() => {
    var o;
    typeof t == "function" && t.bind(e.params)(), (o = h.eventEmitter) === null || o === void 0 || o.emit("didClose"), e._destroy && e._destroy();
  });
}, Ae = (e) => {
  let t = L();
  if (t || new mt(), t = L(), !t)
    return;
  const o = Le();
  ot() ? R(Ee()) : Ls(t, e), U(o), t.setAttribute("data-loading", "true"), t.setAttribute("aria-busy", "true"), t.focus();
}, Ls = (e, t) => {
  const o = je(), n = Le();
  !o || !n || (!t && X(ce()) && (t = ce()), U(o), t && (R(t), n.setAttribute("data-button-to-replace", t.className), o.insertBefore(n, t)), P([e, o], r.loading));
}, Ss = (e, t) => {
  t.input === "select" || t.input === "radio" ? Ds(e, t) : ["text", "email", "number", "tel", "textarea"].some((o) => o === t.input) && (ft(t.inputValue) || bt(t.inputValue)) && (Ae(ce()), _s(e, t));
}, Ms = (e, t) => {
  const o = e.getInput();
  if (!o)
    return null;
  switch (t.input) {
    case "checkbox":
      return Bs(o);
    case "radio":
      return Ts(o);
    case "file":
      return Os(o);
    default:
      return t.inputAutoTrim ? o.value.trim() : o.value;
  }
}, Bs = (e) => e.checked ? 1 : 0, Ts = (e) => e.checked ? e.value : null, Os = (e) => e.files && e.files.length ? e.getAttribute("multiple") !== null ? e.files : e.files[0] : null, Ds = (e, t) => {
  const o = L();
  if (!o)
    return;
  const n = (s) => {
    t.input === "select" ? zs(o, Ke(s), t) : t.input === "radio" && js(o, Ke(s), t);
  };
  ft(t.inputOptions) || bt(t.inputOptions) ? (Ae(ce()), _e(t.inputOptions).then((s) => {
    e.hideLoading(), n(s);
  })) : typeof t.inputOptions == "object" ? n(t.inputOptions) : ye(`Unexpected type of inputOptions! Expected object, Map or Promise, got ${typeof t.inputOptions}`);
}, _s = (e, t) => {
  const o = e.getInput();
  o && (R(o), _e(t.inputValue).then((n) => {
    o.value = t.input === "number" ? `${parseFloat(n) || 0}` : `${n}`, U(o), o.focus(), e.hideLoading();
  }).catch((n) => {
    ye(`Error in inputValue promise: ${n}`), o.value = "", U(o), o.focus(), e.hideLoading();
  }));
};
function zs(e, t, o) {
  const n = we(e, r.select);
  if (!n)
    return;
  const s = (a, w, m) => {
    const u = document.createElement("option");
    u.value = m, te(u, w), u.selected = ko(m, o.inputValue), a.appendChild(u);
  };
  t.forEach((a) => {
    const w = a[0], m = a[1];
    if (Array.isArray(m)) {
      const u = document.createElement("optgroup");
      u.label = w, u.disabled = !1, n.appendChild(u), m.forEach((k) => s(u, k[1], k[0]));
    } else
      s(n, m, w);
  }), n.focus();
}
function js(e, t, o) {
  const n = we(e, r.radio);
  if (!n)
    return;
  t.forEach((a) => {
    const w = a[0], m = a[1], u = document.createElement("input"), k = document.createElement("label");
    u.type = "radio", u.name = r.radio, u.value = w, ko(w, o.inputValue) && (u.checked = !0);
    const S = document.createElement("span");
    te(S, m), S.className = r.label, k.appendChild(u), k.appendChild(S), n.appendChild(k);
  });
  const s = n.querySelectorAll("input");
  s.length && s[0].focus();
}
const Ke = (e) => {
  const t = [];
  return e instanceof Map ? e.forEach((o, n) => {
    let s = o;
    typeof s == "object" && (s = Ke(s)), t.push([n, s]);
  }) : Object.keys(e).forEach((o) => {
    let n = e[o];
    typeof n == "object" && (n = Ke(n)), t.push([o, n]);
  }), t;
}, ko = (e, t) => !!t && t !== null && t !== void 0 && t.toString() === e.toString(), Hs = (e) => {
  const t = D.innerParams.get(e);
  e.disableButtons(), t.input ? $o(e, "confirm") : Mt(e, !0);
}, Is = (e) => {
  const t = D.innerParams.get(e);
  e.disableButtons(), t.returnInputValueOnDeny ? $o(e, "deny") : St(e, !1);
}, Vs = (e, t) => {
  e.disableButtons(), t(Se.cancel);
}, $o = (e, t) => {
  const o = D.innerParams.get(e);
  if (!o.input) {
    ye(`The "input" parameter is needed to be set when using returnInputValueOn${gt(t)}`);
    return;
  }
  const n = e.getInput(), s = Ms(e, o);
  o.inputValidator ? qs(e, s, t) : n && !n.checkValidity() ? (e.enableButtons(), e.showValidationMessage(o.validationMessage || n.validationMessage)) : t === "deny" ? St(e, s) : Mt(e, s);
}, qs = (e, t, o) => {
  const n = D.innerParams.get(e);
  e.disableInput(), Promise.resolve().then(() => _e(n.inputValidator(t, n.validationMessage))).then((s) => {
    e.enableButtons(), e.enableInput(), s ? e.showValidationMessage(s) : o === "deny" ? St(e, t) : Mt(e, t);
  });
}, St = (e, t) => {
  const o = D.innerParams.get(e);
  o.showLoaderOnDeny && Ae(xe()), o.preDeny ? (e.isAwaitingPromise = !0, Promise.resolve().then(() => _e(o.preDeny(t, o.validationMessage))).then((n) => {
    n === !1 ? (e.hideLoading(), Ve(e)) : e.close(
      /** @type SweetAlertResult */
      {
        isDenied: !0,
        value: typeof n > "u" ? t : n
      }
    );
  }).catch((n) => Co(e, n))) : e.close(
    /** @type SweetAlertResult */
    {
      isDenied: !0,
      value: t
    }
  );
}, Nt = (e, t) => {
  e.close(
    /** @type SweetAlertResult */
    {
      isConfirmed: !0,
      value: t
    }
  );
}, Co = (e, t) => {
  e.rejectPromise(t);
}, Mt = (e, t) => {
  const o = D.innerParams.get(e);
  o.showLoaderOnConfirm && Ae(), o.preConfirm ? (e.resetValidationMessage(), e.isAwaitingPromise = !0, Promise.resolve().then(() => _e(o.preConfirm(t, o.validationMessage))).then((n) => {
    X(et()) || n === !1 ? (e.hideLoading(), Ve(e)) : Nt(e, typeof n > "u" ? t : n);
  }).catch((n) => Co(e, n))) : Nt(e, t);
};
function Xe() {
  const e = D.innerParams.get(this);
  if (!e)
    return;
  const t = D.domCache.get(this);
  R(t.loader), ot() ? e.icon && U(Ee()) : Ns(t), se([t.popup, t.actions], r.loading), t.popup.removeAttribute("aria-busy"), t.popup.removeAttribute("data-loading"), t.confirmButton.disabled = !1, t.denyButton.disabled = !1, t.cancelButton.disabled = !1;
}
const Ns = (e) => {
  const t = e.loader.getAttribute("data-button-to-replace"), o = t ? e.popup.getElementsByClassName(t) : [];
  o.length ? U(
    /** @type {HTMLElement} */
    o[0],
    "inline-block"
  ) : pn() && R(e.actions);
};
function Ao() {
  const e = D.innerParams.get(this), t = D.domCache.get(this);
  return t ? nt(t.popup, e.input) : null;
}
function Eo(e, t, o) {
  const n = D.domCache.get(e);
  t.forEach((s) => {
    n[s].disabled = o;
  });
}
function Po(e, t) {
  const o = L();
  if (!(!o || !e))
    if (e.type === "radio") {
      const n = o.querySelectorAll(`[name="${r.radio}"]`);
      for (let s = 0; s < n.length; s++)
        n[s].disabled = t;
    } else
      e.disabled = t;
}
function Lo() {
  Eo(this, ["confirmButton", "denyButton", "cancelButton"], !1);
}
function So() {
  Eo(this, ["confirmButton", "denyButton", "cancelButton"], !0);
}
function Mo() {
  Po(this.getInput(), !1);
}
function Bo() {
  Po(this.getInput(), !0);
}
function To(e) {
  const t = D.domCache.get(this), o = D.innerParams.get(this);
  te(t.validationMessage, e), t.validationMessage.className = r["validation-message"], o.customClass && o.customClass.validationMessage && P(t.validationMessage, o.customClass.validationMessage), U(t.validationMessage);
  const n = this.getInput();
  n && (n.setAttribute("aria-invalid", "true"), n.setAttribute("aria-describedby", r["validation-message"]), no(n), P(n, r.inputerror));
}
function Oo() {
  const e = D.domCache.get(this);
  e.validationMessage && R(e.validationMessage);
  const t = this.getInput();
  t && (t.removeAttribute("aria-invalid"), t.removeAttribute("aria-describedby"), se(t, r.inputerror));
}
const he = {
  title: "",
  titleText: "",
  text: "",
  html: "",
  footer: "",
  icon: void 0,
  iconColor: void 0,
  iconHtml: void 0,
  template: void 0,
  toast: !1,
  draggable: !1,
  animation: !0,
  theme: "light",
  showClass: {
    popup: "swal2-show",
    backdrop: "swal2-backdrop-show",
    icon: "swal2-icon-show"
  },
  hideClass: {
    popup: "swal2-hide",
    backdrop: "swal2-backdrop-hide",
    icon: "swal2-icon-hide"
  },
  customClass: {},
  target: "body",
  color: void 0,
  backdrop: !0,
  heightAuto: !0,
  allowOutsideClick: !0,
  allowEscapeKey: !0,
  allowEnterKey: !0,
  stopKeydownPropagation: !0,
  keydownListenerCapture: !1,
  showConfirmButton: !0,
  showDenyButton: !1,
  showCancelButton: !1,
  preConfirm: void 0,
  preDeny: void 0,
  confirmButtonText: "OK",
  confirmButtonAriaLabel: "",
  confirmButtonColor: void 0,
  denyButtonText: "No",
  denyButtonAriaLabel: "",
  denyButtonColor: void 0,
  cancelButtonText: "Cancel",
  cancelButtonAriaLabel: "",
  cancelButtonColor: void 0,
  buttonsStyling: !0,
  reverseButtons: !1,
  focusConfirm: !0,
  focusDeny: !1,
  focusCancel: !1,
  returnFocus: !0,
  showCloseButton: !1,
  closeButtonHtml: "&times;",
  closeButtonAriaLabel: "Close this dialog",
  loaderHtml: "",
  showLoaderOnConfirm: !1,
  showLoaderOnDeny: !1,
  imageUrl: void 0,
  imageWidth: void 0,
  imageHeight: void 0,
  imageAlt: "",
  timer: void 0,
  timerProgressBar: !1,
  width: void 0,
  padding: void 0,
  background: void 0,
  input: void 0,
  inputPlaceholder: "",
  inputLabel: "",
  inputValue: "",
  inputOptions: {},
  inputAutoFocus: !0,
  inputAutoTrim: !0,
  inputAttributes: {},
  inputValidator: void 0,
  returnInputValueOnDeny: !1,
  validationMessage: void 0,
  grow: !1,
  position: "center",
  progressSteps: [],
  currentProgressStep: void 0,
  progressStepsDistance: void 0,
  willOpen: void 0,
  didOpen: void 0,
  didRender: void 0,
  willClose: void 0,
  didClose: void 0,
  didDestroy: void 0,
  scrollbarPadding: !0,
  topLayer: !1
}, Ys = ["allowEscapeKey", "allowOutsideClick", "background", "buttonsStyling", "cancelButtonAriaLabel", "cancelButtonColor", "cancelButtonText", "closeButtonAriaLabel", "closeButtonHtml", "color", "confirmButtonAriaLabel", "confirmButtonColor", "confirmButtonText", "currentProgressStep", "customClass", "denyButtonAriaLabel", "denyButtonColor", "denyButtonText", "didClose", "didDestroy", "draggable", "footer", "hideClass", "html", "icon", "iconColor", "iconHtml", "imageAlt", "imageHeight", "imageUrl", "imageWidth", "preConfirm", "preDeny", "progressSteps", "returnFocus", "reverseButtons", "showCancelButton", "showCloseButton", "showConfirmButton", "showDenyButton", "text", "title", "titleText", "theme", "willClose"], Us = {
  allowEnterKey: void 0
}, Fs = ["allowOutsideClick", "allowEnterKey", "backdrop", "draggable", "focusConfirm", "focusDeny", "focusCancel", "returnFocus", "heightAuto", "keydownListenerCapture"], Do = (e) => Object.prototype.hasOwnProperty.call(he, e), _o = (e) => Ys.indexOf(e) !== -1, zo = (e) => Us[e], Rs = (e) => {
  Do(e) || W(`Unknown parameter "${e}"`);
}, Ws = (e) => {
  Fs.includes(e) && W(`The parameter "${e}" is incompatible with toasts`);
}, Zs = (e) => {
  const t = zo(e);
  t && Gt(e, t);
}, jo = (e) => {
  e.backdrop === !1 && e.allowOutsideClick && W('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`'), e.theme && !["light", "dark", "auto", "minimal", "borderless", "bootstrap-4", "bootstrap-4-light", "bootstrap-4-dark", "bootstrap-5", "bootstrap-5-light", "bootstrap-5-dark", "material-ui", "material-ui-light", "material-ui-dark", "embed-iframe", "bulma", "bulma-light", "bulma-dark"].includes(e.theme) && W(`Invalid theme "${e.theme}"`);
  for (const t in e)
    Rs(t), e.toast && Ws(t), Zs(t);
};
function Ho(e) {
  const t = Z(), o = L(), n = D.innerParams.get(this);
  if (!o || ue(o, n.hideClass.popup)) {
    W("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");
    return;
  }
  const s = Ks(e), a = Object.assign({}, n, s);
  jo(a), t && (t.dataset.swal2Theme = a.theme), ho(this, a), D.innerParams.set(this, a), Object.defineProperties(this, {
    params: {
      value: Object.assign({}, this.params, e),
      writable: !1,
      enumerable: !0
    }
  });
}
const Ks = (e) => {
  const t = {};
  return Object.keys(e).forEach((o) => {
    if (_o(o)) {
      const n = (
        /** @type {Record<string, any>} */
        e
      );
      t[o] = n[o];
    } else
      W(`Invalid parameter to update: ${o}`);
  }), t;
};
function Io() {
  var e;
  const t = D.domCache.get(this), o = D.innerParams.get(this);
  if (!o) {
    Vo(this);
    return;
  }
  t.popup && h.swalCloseEventFinishedCallback && (h.swalCloseEventFinishedCallback(), delete h.swalCloseEventFinishedCallback), typeof o.didDestroy == "function" && o.didDestroy(), (e = h.eventEmitter) === null || e === void 0 || e.emit("didDestroy"), Xs(this);
}
const Xs = (e) => {
  Vo(e), delete e.params, delete h.keydownHandler, delete h.keydownTarget, delete h.currentInstance;
}, Vo = (e) => {
  e.isAwaitingPromise ? (lt(D, e), e.isAwaitingPromise = !0) : (lt(Ce, e), lt(D, e), delete e.isAwaitingPromise, delete e.disableButtons, delete e.enableButtons, delete e.getInput, delete e.disableInput, delete e.enableInput, delete e.hideLoading, delete e.disableLoading, delete e.showValidationMessage, delete e.resetValidationMessage, delete e.close, delete e.closePopup, delete e.closeModal, delete e.closeToast, delete e.rejectPromise, delete e.update, delete e._destroy);
}, lt = (e, t) => {
  for (const o in e)
    e[o].delete(t);
};
var Js = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  _destroy: Io,
  close: me,
  closeModal: me,
  closePopup: me,
  closeToast: me,
  disableButtons: So,
  disableInput: Bo,
  disableLoading: Xe,
  enableButtons: Lo,
  enableInput: Mo,
  getInput: Ao,
  handleAwaitingPromise: Ve,
  hideLoading: Xe,
  rejectPromise: xo,
  resetValidationMessage: Oo,
  showValidationMessage: To,
  update: Ho
});
const Qs = (e, t, o) => {
  e.toast ? Gs(e, t, o) : (tr(t), or(t), nr(e, t, o));
}, Gs = (e, t, o) => {
  t.popup.onclick = () => {
    e && (er(e) || e.timer || e.input) || o(Se.close);
  };
}, er = (e) => !!(e.showConfirmButton || e.showDenyButton || e.showCancelButton || e.showCloseButton);
let Je = !1;
const tr = (e) => {
  e.popup.onmousedown = () => {
    e.container.onmouseup = function(t) {
      e.container.onmouseup = () => {
      }, t.target === e.container && (Je = !0);
    };
  };
}, or = (e) => {
  e.container.onmousedown = (t) => {
    t.target === e.container && t.preventDefault(), e.popup.onmouseup = function(o) {
      e.popup.onmouseup = () => {
      }, (o.target === e.popup || o.target instanceof HTMLElement && e.popup.contains(o.target)) && (Je = !0);
    };
  };
}, nr = (e, t, o) => {
  t.container.onclick = (n) => {
    if (Je) {
      Je = !1;
      return;
    }
    n.target === t.container && Ge(e.allowOutsideClick) && o(Se.backdrop);
  };
}, sr = (e) => typeof e == "object" && e.jquery, Yt = (e) => e instanceof Element || sr(e), rr = (e) => {
  const t = {};
  return typeof e[0] == "object" && !Yt(e[0]) ? Object.assign(t, e[0]) : ["title", "html", "icon"].forEach((o, n) => {
    const s = e[n];
    typeof s == "string" || Yt(s) ? t[o] = s : s !== void 0 && ye(`Unexpected type of ${o}! Expected "string" or "Element", got ${typeof s}`);
  }), t;
};
function ar(...e) {
  return new this(...e);
}
function ir(e) {
  class t extends this {
    /**
     * @param {any} params
     * @param {any} priorityMixinParams
     */
    _main(n, s) {
      return super._main(n, Object.assign({}, e, s));
    }
  }
  return t;
}
const lr = () => h.timeout && h.timeout.getTimerLeft(), qo = () => {
  if (h.timeout)
    return fn(), h.timeout.stop();
}, No = () => {
  if (h.timeout) {
    const e = h.timeout.start();
    return At(e), e;
  }
}, cr = () => {
  const e = h.timeout;
  return e && (e.running ? qo() : No());
}, ur = (e) => {
  if (h.timeout) {
    const t = h.timeout.increase(e);
    return At(t, !0), t;
  }
}, dr = () => !!(h.timeout && h.timeout.isRunning());
let Ut = !1;
const wt = {};
function wr(e = "data-swal-template") {
  wt[e] = this, Ut || (document.body.addEventListener("click", mr), Ut = !0);
}
const mr = (e) => {
  for (let t = (
    /** @type {any} */
    e.target
  ); t && t !== document; t = t.parentNode)
    for (const o in wt) {
      const n = t.getAttribute && t.getAttribute(o);
      if (n) {
        wt[o].fire({
          template: n
        });
        return;
      }
    }
};
class hr {
  constructor() {
    this.events = {};
  }
  /**
   * @param {string} eventName
   * @returns {EventHandlers}
   */
  _getHandlersByEventName(t) {
    return typeof this.events[t] > "u" && (this.events[t] = []), this.events[t];
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  on(t, o) {
    const n = this._getHandlersByEventName(t);
    n.includes(o) || n.push(o);
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  once(t, o) {
    const n = (...s) => {
      this.removeListener(t, n), o.apply(this, s);
    };
    this.on(t, n);
  }
  /**
   * @param {string} eventName
   * @param {...any} args
   */
  emit(t, ...o) {
    this._getHandlersByEventName(t).forEach(
      /**
       * @param {EventHandler} eventHandler
       */
      (n) => {
        try {
          n.apply(this, o);
        } catch (s) {
          console.error(s);
        }
      }
    );
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  removeListener(t, o) {
    const n = this._getHandlersByEventName(t), s = n.indexOf(o);
    s > -1 && n.splice(s, 1);
  }
  /**
   * @param {string} eventName
   */
  removeAllListeners(t) {
    this.events[t] !== void 0 && (this.events[t].length = 0);
  }
  reset() {
    this.events = {};
  }
}
h.eventEmitter = new hr();
const pr = (e, t) => {
  h.eventEmitter && h.eventEmitter.on(e, t);
}, gr = (e, t) => {
  h.eventEmitter && h.eventEmitter.once(e, t);
}, fr = (e, t) => {
  if (h.eventEmitter) {
    if (!e) {
      h.eventEmitter.reset();
      return;
    }
    t ? h.eventEmitter.removeListener(e, t) : h.eventEmitter.removeAllListeners(e);
  }
};
var br = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  argsToParams: rr,
  bindClickHandler: wr,
  clickCancel: rs,
  clickConfirm: po,
  clickDeny: ss,
  enableLoading: Ae,
  fire: ar,
  getActions: je,
  getCancelButton: Pe,
  getCloseButton: xt,
  getConfirmButton: ce,
  getContainer: Z,
  getDenyButton: xe,
  getFocusableElements: kt,
  getFooter: oo,
  getHtmlContainer: vt,
  getIcon: Ee,
  getIconContent: un,
  getImage: to,
  getInputLabel: dn,
  getLoader: Le,
  getPopup: L,
  getProgressSteps: yt,
  getTimerLeft: lr,
  getTimerProgressBar: tt,
  getTitle: eo,
  getValidationMessage: et,
  increaseTimer: ur,
  isDeprecatedParameter: zo,
  isLoading: mn,
  isTimerRunning: dr,
  isUpdatableParameter: _o,
  isValidParameter: Do,
  isVisible: ns,
  mixin: ir,
  off: fr,
  on: pr,
  once: gr,
  resumeTimer: No,
  showLoading: Ae,
  stopTimer: qo,
  toggleTimer: cr
});
class vr {
  /**
   * @param {() => void} callback
   * @param {number} delay
   */
  constructor(t, o) {
    this.callback = t, this.remaining = o, this.running = !1, this.start();
  }
  /**
   * @returns {number}
   */
  start() {
    return this.running || (this.running = !0, this.started = /* @__PURE__ */ new Date(), this.id = setTimeout(this.callback, this.remaining)), this.remaining;
  }
  /**
   * @returns {number}
   */
  stop() {
    return this.started && this.running && (this.running = !1, clearTimeout(this.id), this.remaining -= (/* @__PURE__ */ new Date()).getTime() - this.started.getTime()), this.remaining;
  }
  /**
   * @param {number} n
   * @returns {number}
   */
  increase(t) {
    const o = this.running;
    return o && this.stop(), this.remaining += t, o && this.start(), this.remaining;
  }
  /**
   * @returns {number}
   */
  getTimerLeft() {
    return this.running && (this.stop(), this.start()), this.remaining;
  }
  /**
   * @returns {boolean}
   */
  isRunning() {
    return this.running;
  }
}
const Yo = ["swal-title", "swal-html", "swal-footer"], yr = (e) => {
  const t = typeof e.template == "string" ? (
    /** @type {HTMLTemplateElement} */
    document.querySelector(e.template)
  ) : e.template;
  if (!t)
    return {};
  const o = t.content;
  return Lr(o), Object.assign(xr(o), kr(o), $r(o), Cr(o), Ar(o), Er(o), Pr(o, Yo));
}, xr = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-param")).forEach((o) => {
    ve(o, ["name", "value"]);
    const n = (
      /** @type {keyof SweetAlertOptions} */
      o.getAttribute("name")
    ), s = o.getAttribute("value");
    !n || !s || (n in he && typeof he[
      /** @type {keyof typeof defaultParams} */
      n
    ] == "boolean" ? t[n] = s !== "false" : n in he && typeof he[
      /** @type {keyof typeof defaultParams} */
      n
    ] == "object" ? t[n] = JSON.parse(s) : t[n] = s);
  }), t;
}, kr = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-function-param")).forEach((o) => {
    const n = (
      /** @type {keyof SweetAlertOptions} */
      o.getAttribute("name")
    ), s = o.getAttribute("value");
    !n || !s || (t[n] = new Function(`return ${s}`)());
  }), t;
}, $r = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-button")).forEach((o) => {
    ve(o, ["type", "color", "aria-label"]);
    const n = o.getAttribute("type");
    if (!(!n || !["confirm", "cancel", "deny"].includes(n))) {
      if (t[`${n}ButtonText`] = o.innerHTML, t[`show${gt(n)}Button`] = !0, o.hasAttribute("color")) {
        const s = o.getAttribute("color");
        s !== null && (t[`${n}ButtonColor`] = s);
      }
      if (o.hasAttribute("aria-label")) {
        const s = o.getAttribute("aria-label");
        s !== null && (t[`${n}ButtonAriaLabel`] = s);
      }
    }
  }), t;
}, Cr = (e) => {
  const t = {}, o = e.querySelector("swal-image");
  return o && (ve(o, ["src", "width", "height", "alt"]), o.hasAttribute("src") && (t.imageUrl = o.getAttribute("src") || void 0), o.hasAttribute("width") && (t.imageWidth = o.getAttribute("width") || void 0), o.hasAttribute("height") && (t.imageHeight = o.getAttribute("height") || void 0), o.hasAttribute("alt") && (t.imageAlt = o.getAttribute("alt") || void 0)), t;
}, Ar = (e) => {
  const t = {}, o = e.querySelector("swal-icon");
  return o && (ve(o, ["type", "color"]), o.hasAttribute("type") && (t.icon = o.getAttribute("type")), o.hasAttribute("color") && (t.iconColor = o.getAttribute("color")), t.iconHtml = o.innerHTML), t;
}, Er = (e) => {
  const t = {}, o = e.querySelector("swal-input");
  o && (ve(o, ["type", "label", "placeholder", "value"]), t.input = o.getAttribute("type") || "text", o.hasAttribute("label") && (t.inputLabel = o.getAttribute("label")), o.hasAttribute("placeholder") && (t.inputPlaceholder = o.getAttribute("placeholder")), o.hasAttribute("value") && (t.inputValue = o.getAttribute("value")));
  const n = Array.from(e.querySelectorAll("swal-input-option"));
  return n.length && (t.inputOptions = {}, n.forEach((s) => {
    ve(s, ["value"]);
    const a = s.getAttribute("value");
    if (!a)
      return;
    const w = s.innerHTML;
    t.inputOptions[a] = w;
  })), t;
}, Pr = (e, t) => {
  const o = {};
  for (const n in t) {
    const s = t[n], a = e.querySelector(s);
    a && (ve(a, []), o[s.replace(/^swal-/, "")] = a.innerHTML.trim());
  }
  return o;
}, Lr = (e) => {
  const t = Yo.concat(["swal-param", "swal-function-param", "swal-button", "swal-image", "swal-icon", "swal-input", "swal-input-option"]);
  Array.from(e.children).forEach((o) => {
    const n = o.tagName.toLowerCase();
    t.includes(n) || W(`Unrecognized element <${n}>`);
  });
}, ve = (e, t) => {
  Array.from(e.attributes).forEach((o) => {
    t.indexOf(o.name) === -1 && W([`Unrecognized attribute "${o.name}" on <${e.tagName.toLowerCase()}>.`, `${t.length ? `Allowed attributes are: ${t.join(", ")}` : "To set the value, use HTML within the element."}`]);
  });
}, Uo = 10, Sr = (e) => {
  var t, o;
  const n = Z(), s = L();
  if (!n || !s)
    return;
  typeof e.willOpen == "function" && e.willOpen(s), (t = h.eventEmitter) === null || t === void 0 || t.emit("willOpen", s);
  const a = window.getComputedStyle(document.body).overflowY;
  if (Tr(n, s, e), setTimeout(() => {
    Mr(n, s);
  }, Uo), $t() && (Br(n, e.scrollbarPadding !== void 0 ? e.scrollbarPadding : !1, a), ms()), !ot() && !h.previousActiveElement && (h.previousActiveElement = document.activeElement), typeof e.didOpen == "function") {
    const w = e.didOpen;
    setTimeout(() => w(s));
  }
  (o = h.eventEmitter) === null || o === void 0 || o.emit("didOpen", s);
}, Qe = (e) => {
  const t = L();
  if (!t || e.target !== t)
    return;
  const o = Z();
  o && (t.removeEventListener("animationend", Qe), t.removeEventListener("transitionend", Qe), o.style.overflowY = "auto", se(o, r["no-transition"]));
}, Mr = (e, t) => {
  ro(t) ? (e.style.overflowY = "hidden", t.addEventListener("animationend", Qe), t.addEventListener("transitionend", Qe)) : e.style.overflowY = "auto";
}, Br = (e, t, o) => {
  hs(), t && o !== "hidden" && xs(o), setTimeout(() => {
    e.scrollTop = 0;
  });
}, Tr = (e, t, o) => {
  var n;
  (n = o.showClass) !== null && n !== void 0 && n.backdrop && P(e, o.showClass.backdrop), o.animation ? (t.style.setProperty("opacity", "0", "important"), U(t, "grid"), setTimeout(() => {
    var s;
    (s = o.showClass) !== null && s !== void 0 && s.popup && P(t, o.showClass.popup), t.style.removeProperty("opacity");
  }, Uo)) : U(t, "grid"), P([document.documentElement, document.body], r.shown), o.heightAuto && o.backdrop && !o.toast && P([document.documentElement, document.body], r["height-auto"]);
};
var Ft = {
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  email: (e, t) => /^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid email address"),
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  url: (e, t) => /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid URL")
};
function Or(e) {
  e.inputValidator || (e.input === "email" && (e.inputValidator = Ft.email), e.input === "url" && (e.inputValidator = Ft.url));
}
function Dr(e) {
  (!e.target || typeof e.target == "string" && !document.querySelector(e.target) || typeof e.target != "string" && !e.target.appendChild) && (W('Target parameter is not valid, defaulting to "body"'), e.target = "body");
}
function _r(e) {
  Or(e), e.showLoaderOnConfirm && !e.preConfirm && W(`showLoaderOnConfirm is set to true, but preConfirm is not defined.
showLoaderOnConfirm should be used together with preConfirm, see usage example:
https://sweetalert2.github.io/#ajax-request`), Dr(e), typeof e.title == "string" && (e.title = e.title.split(`
`).join("<br />")), An(e);
}
let le;
var Ye = /* @__PURE__ */ new WeakMap();
class q {
  /**
   * @param {...(SweetAlertOptions | string)} args
   * @this {SweetAlert}
   */
  constructor(...t) {
    if (tn(
      this,
      Ye,
      /** @type {Promise<SweetAlertResult>} */
      Promise.resolve({
        isConfirmed: !1,
        isDenied: !1,
        isDismissed: !0
      })
    ), typeof window > "u")
      return;
    le = this;
    const o = Object.freeze(this.constructor.argsToParams(t));
    this.params = o, this.isAwaitingPromise = !1, on(Ye, this, this._main(le.params));
  }
  /**
   * @param {any} userParams
   * @param {any} mixinParams
   */
  _main(t, o = {}) {
    if (jo(Object.assign({}, o, t)), h.currentInstance) {
      const a = Ce.swalPromiseResolve.get(h.currentInstance), {
        isAwaitingPromise: w
      } = h.currentInstance;
      h.currentInstance._destroy(), w || a({
        isDismissed: !0
      }), $t() && bo();
    }
    h.currentInstance = le;
    const n = jr(t, o);
    _r(n), Object.freeze(n), h.timeout && (h.timeout.stop(), delete h.timeout), clearTimeout(h.restoreFocusTimeout);
    const s = Hr(le);
    return ho(le, n), D.innerParams.set(le, n), zr(le, s, n);
  }
  // `catch` cannot be the name of a module export, so we define our thenable methods here instead
  /**
   * @param {any} onFulfilled
   */
  then(t) {
    return _t(Ye, this).then(t);
  }
  /**
   * @param {any} onFinally
   */
  finally(t) {
    return _t(Ye, this).finally(t);
  }
}
const zr = (e, t, o) => new Promise((n, s) => {
  const a = (w) => {
    e.close({
      isDismissed: !0,
      dismiss: w,
      isConfirmed: !1,
      isDenied: !1
    });
  };
  Ce.swalPromiseResolve.set(e, n), Ce.swalPromiseReject.set(e, s), t.confirmButton.onclick = () => {
    Hs(e);
  }, t.denyButton.onclick = () => {
    Is(e);
  }, t.cancelButton.onclick = () => {
    Vs(e, a);
  }, t.closeButton.onclick = () => {
    a(Se.close);
  }, Qs(o, t, a), as(h, o, a), Ss(e, o), Sr(o), Ir(h, o, a), Vr(t, o), setTimeout(() => {
    t.container.scrollTop = 0;
  });
}), jr = (e, t) => {
  const o = yr(e), n = Object.assign({}, he, t, o, e);
  return n.showClass = Object.assign({}, he.showClass, n.showClass), n.hideClass = Object.assign({}, he.hideClass, n.hideClass), n.animation === !1 && (n.showClass = {
    backdrop: "swal2-noanimation"
  }, n.hideClass = {}), n;
}, Hr = (e) => {
  const t = (
    /** @type {DomCache} */
    {
      popup: (
        /** @type {HTMLElement} */
        L()
      ),
      container: (
        /** @type {HTMLElement} */
        Z()
      ),
      actions: (
        /** @type {HTMLElement} */
        je()
      ),
      confirmButton: (
        /** @type {HTMLElement} */
        ce()
      ),
      denyButton: (
        /** @type {HTMLElement} */
        xe()
      ),
      cancelButton: (
        /** @type {HTMLElement} */
        Pe()
      ),
      loader: (
        /** @type {HTMLElement} */
        Le()
      ),
      closeButton: (
        /** @type {HTMLElement} */
        xt()
      ),
      validationMessage: (
        /** @type {HTMLElement} */
        et()
      ),
      progressSteps: (
        /** @type {HTMLElement} */
        yt()
      )
    }
  );
  return D.domCache.set(e, t), t;
}, Ir = (e, t, o) => {
  const n = tt();
  R(n), t.timer && (e.timeout = new vr(() => {
    o("timer"), delete e.timeout;
  }, t.timer), t.timerProgressBar && n && (U(n), G(n, t, "timerProgressBar"), setTimeout(() => {
    e.timeout && e.timeout.running && At(
      /** @type {number} */
      t.timer
    );
  })));
}, Vr = (e, t) => {
  if (!t.toast) {
    if (!Ge(t.allowEnterKey)) {
      Gt("allowEnterKey"), Yr();
      return;
    }
    qr(e) || Nr(e, t) || dt(-1, 1);
  }
}, qr = (e) => {
  const t = Array.from(e.popup.querySelectorAll("[autofocus]"));
  for (const o of t)
    if (o instanceof HTMLElement && X(o))
      return o.focus(), !0;
  return !1;
}, Nr = (e, t) => t.focusDeny && X(e.denyButton) ? (e.denyButton.focus(), !0) : t.focusCancel && X(e.cancelButton) ? (e.cancelButton.focus(), !0) : t.focusConfirm && X(e.confirmButton) ? (e.confirmButton.focus(), !0) : !1, Yr = () => {
  document.activeElement instanceof HTMLElement && typeof document.activeElement.blur == "function" && document.activeElement.blur();
};
q.prototype.disableButtons = So;
q.prototype.enableButtons = Lo;
q.prototype.getInput = Ao;
q.prototype.disableInput = Bo;
q.prototype.enableInput = Mo;
q.prototype.hideLoading = Xe;
q.prototype.disableLoading = Xe;
q.prototype.showValidationMessage = To;
q.prototype.resetValidationMessage = Oo;
q.prototype.close = me;
q.prototype.closePopup = me;
q.prototype.closeModal = me;
q.prototype.closeToast = me;
q.prototype.rejectPromise = xo;
q.prototype.update = Ho;
q.prototype._destroy = Io;
Object.assign(q, br);
Object.keys(Js).forEach((e) => {
  q[e] = function(...t) {
    if (le && le[e])
      return le[e](...t);
  };
});
q.DismissReason = Se;
q.version = "11.26.17";
const mt = q;
mt.default = mt;
typeof document < "u" && function(e, t) {
  var o = e.createElement("style");
  if (e.getElementsByTagName("head")[0].appendChild(o), o.styleSheet) o.styleSheet.disabled || (o.styleSheet.cssText = t);
  else try {
    o.innerHTML = t;
  } catch {
    o.innerText = t;
  }
}(document, ':root{--swal2-outline: 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-container-padding: 0.625em;--swal2-backdrop: rgba(0, 0, 0, 0.4);--swal2-backdrop-transition: background-color 0.15s;--swal2-width: 32em;--swal2-padding: 0 0 1.25em;--swal2-border: none;--swal2-border-radius: 0.3125rem;--swal2-background: white;--swal2-color: #545454;--swal2-show-animation: swal2-show 0.3s;--swal2-hide-animation: swal2-hide 0.15s forwards;--swal2-icon-zoom: 1;--swal2-icon-animations: true;--swal2-title-padding: 0.8em 1em 0;--swal2-html-container-padding: 1em 1.6em 0.3em;--swal2-input-border: 1px solid #d9d9d9;--swal2-input-border-radius: 0.1875em;--swal2-input-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-background: transparent;--swal2-input-transition: border-color 0.2s, box-shadow 0.2s;--swal2-input-hover-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-focus-border: 1px solid #b4dbed;--swal2-input-focus-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-progress-step-background: #add8e6;--swal2-validation-message-background: #f0f0f0;--swal2-validation-message-color: #666;--swal2-footer-border-color: #eee;--swal2-footer-background: transparent;--swal2-footer-color: inherit;--swal2-timer-progress-bar-background: rgba(0, 0, 0, 0.3);--swal2-close-button-position: initial;--swal2-close-button-inset: auto;--swal2-close-button-font-size: 2.5em;--swal2-close-button-color: #ccc;--swal2-close-button-transition: color 0.2s, box-shadow 0.2s;--swal2-close-button-outline: initial;--swal2-close-button-box-shadow: inset 0 0 0 3px transparent;--swal2-close-button-focus-box-shadow: inset var(--swal2-outline);--swal2-close-button-hover-transform: none;--swal2-actions-justify-content: center;--swal2-actions-width: auto;--swal2-actions-margin: 1.25em auto 0;--swal2-actions-padding: 0;--swal2-actions-border-radius: 0;--swal2-actions-background: transparent;--swal2-action-button-transition: background-color 0.2s, box-shadow 0.2s;--swal2-action-button-hover: black 10%;--swal2-action-button-active: black 10%;--swal2-confirm-button-box-shadow: none;--swal2-confirm-button-border-radius: 0.25em;--swal2-confirm-button-background-color: #7066e0;--swal2-confirm-button-color: #fff;--swal2-deny-button-box-shadow: none;--swal2-deny-button-border-radius: 0.25em;--swal2-deny-button-background-color: #dc3741;--swal2-deny-button-color: #fff;--swal2-cancel-button-box-shadow: none;--swal2-cancel-button-border-radius: 0.25em;--swal2-cancel-button-background-color: #6e7881;--swal2-cancel-button-color: #fff;--swal2-toast-show-animation: swal2-toast-show 0.5s;--swal2-toast-hide-animation: swal2-toast-hide 0.1s forwards;--swal2-toast-border: none;--swal2-toast-box-shadow: 0 0 1px hsl(0deg 0% 0% / 0.075), 0 1px 2px hsl(0deg 0% 0% / 0.075), 1px 2px 4px hsl(0deg 0% 0% / 0.075), 1px 3px 8px hsl(0deg 0% 0% / 0.075), 2px 4px 16px hsl(0deg 0% 0% / 0.075)}[data-swal2-theme=dark]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}@media(prefers-color-scheme: dark){[data-swal2-theme=auto]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:all}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px var(--swal2-backdrop)}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}@media print{body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown) .swal2-container{position:static !important}}div:where(.swal2-container){display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:"top-start     top            top-end" "center-start  center         center-end" "bottom-start  bottom-center  bottom-end";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:var(--swal2-container-padding);overflow-x:hidden;transition:var(--swal2-backdrop-transition);-webkit-overflow-scrolling:touch}div:where(.swal2-container).swal2-backdrop-show,div:where(.swal2-container).swal2-noanimation{background:var(--swal2-backdrop)}div:where(.swal2-container).swal2-backdrop-hide{background:rgba(0,0,0,0) !important}div:where(.swal2-container).swal2-top-start,div:where(.swal2-container).swal2-center-start,div:where(.swal2-container).swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}div:where(.swal2-container).swal2-top,div:where(.swal2-container).swal2-center,div:where(.swal2-container).swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}div:where(.swal2-container).swal2-top-end,div:where(.swal2-container).swal2-center-end,div:where(.swal2-container).swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}div:where(.swal2-container).swal2-top-start>.swal2-popup{align-self:start}div:where(.swal2-container).swal2-top>.swal2-popup{grid-column:2;place-self:start center}div:where(.swal2-container).swal2-top-end>.swal2-popup,div:where(.swal2-container).swal2-top-right>.swal2-popup{grid-column:3;place-self:start end}div:where(.swal2-container).swal2-center-start>.swal2-popup,div:where(.swal2-container).swal2-center-left>.swal2-popup{grid-row:2;align-self:center}div:where(.swal2-container).swal2-center>.swal2-popup{grid-column:2;grid-row:2;place-self:center center}div:where(.swal2-container).swal2-center-end>.swal2-popup,div:where(.swal2-container).swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;place-self:center end}div:where(.swal2-container).swal2-bottom-start>.swal2-popup,div:where(.swal2-container).swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}div:where(.swal2-container).swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;place-self:end center}div:where(.swal2-container).swal2-bottom-end>.swal2-popup,div:where(.swal2-container).swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;place-self:end end}div:where(.swal2-container).swal2-grow-row>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}div:where(.swal2-container).swal2-grow-column>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}div:where(.swal2-container).swal2-no-transition{transition:none !important}div:where(.swal2-container)[popover]{width:auto;border:0}div:where(.swal2-container) div:where(.swal2-popup){display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:var(--swal2-width);max-width:100%;padding:var(--swal2-padding);border:var(--swal2-border);border-radius:var(--swal2-border-radius);background:var(--swal2-background);color:var(--swal2-color);font-family:inherit;font-size:1rem;container-name:swal2-popup}div:where(.swal2-container) div:where(.swal2-popup):focus{outline:none}div:where(.swal2-container) div:where(.swal2-popup).swal2-loading{overflow-y:hidden}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable{cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable div:where(.swal2-icon){cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging{cursor:grabbing}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging div:where(.swal2-icon){cursor:grabbing}div:where(.swal2-container) h2:where(.swal2-title){position:relative;max-width:100%;margin:0;padding:var(--swal2-title-padding);color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;overflow-wrap:break-word;cursor:initial}div:where(.swal2-container) div:where(.swal2-actions){display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:var(--swal2-actions-justify-content);width:var(--swal2-actions-width);margin:var(--swal2-actions-margin);padding:var(--swal2-actions-padding);border-radius:var(--swal2-actions-border-radius);background:var(--swal2-actions-background)}div:where(.swal2-container) div:where(.swal2-loader){display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}div:where(.swal2-container) button:where(.swal2-styled){margin:.3125em;padding:.625em 1.1em;transition:var(--swal2-action-button-transition);border:none;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}div:where(.swal2-container) button:where(.swal2-styled):not([disabled]){cursor:pointer}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm){border-radius:var(--swal2-confirm-button-border-radius);background:initial;background-color:var(--swal2-confirm-button-background-color);box-shadow:var(--swal2-confirm-button-box-shadow);color:var(--swal2-confirm-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):hover{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):active{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny){border-radius:var(--swal2-deny-button-border-radius);background:initial;background-color:var(--swal2-deny-button-background-color);box-shadow:var(--swal2-deny-button-box-shadow);color:var(--swal2-deny-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):hover{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):active{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel){border-radius:var(--swal2-cancel-button-border-radius);background:initial;background-color:var(--swal2-cancel-button-background-color);box-shadow:var(--swal2-cancel-button-box-shadow);color:var(--swal2-cancel-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):hover{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):active{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):focus-visible{outline:none;box-shadow:var(--swal2-action-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-styled)[disabled]:not(.swal2-loading){opacity:.4}div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-footer){margin:1em 0 0;padding:1em 1em 0;border-top:1px solid var(--swal2-footer-border-color);background:var(--swal2-footer-background);color:var(--swal2-footer-color);font-size:1em;text-align:center;cursor:initial}div:where(.swal2-container) .swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:var(--swal2-border-radius);border-bottom-left-radius:var(--swal2-border-radius)}div:where(.swal2-container) div:where(.swal2-timer-progress-bar){width:100%;height:.25em;background:var(--swal2-timer-progress-bar-background)}div:where(.swal2-container) img:where(.swal2-image){max-width:100%;margin:2em auto 1em;cursor:initial}div:where(.swal2-container) button:where(.swal2-close){position:var(--swal2-close-button-position);inset:var(--swal2-close-button-inset);z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:var(--swal2-close-button-transition);border:none;border-radius:var(--swal2-border-radius);outline:var(--swal2-close-button-outline);background:rgba(0,0,0,0);color:var(--swal2-close-button-color);font-family:monospace;font-size:var(--swal2-close-button-font-size);cursor:pointer;justify-self:end}div:where(.swal2-container) button:where(.swal2-close):hover{transform:var(--swal2-close-button-hover-transform);background:rgba(0,0,0,0);color:#f27474}div:where(.swal2-container) button:where(.swal2-close):focus-visible{outline:none;box-shadow:var(--swal2-close-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-html-container){z-index:1;justify-content:center;margin:0;padding:var(--swal2-html-container-padding);overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;overflow-wrap:break-word;word-break:break-word;cursor:initial}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea),div:where(.swal2-container) select:where(.swal2-select),div:where(.swal2-container) div:where(.swal2-radio),div:where(.swal2-container) label:where(.swal2-checkbox){margin:1em 2em 3px}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea){box-sizing:border-box;width:auto;transition:var(--swal2-input-transition);border:var(--swal2-input-border);border-radius:var(--swal2-input-border-radius);background:var(--swal2-input-background);box-shadow:var(--swal2-input-box-shadow);color:inherit;font-size:1.125em}div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}div:where(.swal2-container) input:where(.swal2-input):hover,div:where(.swal2-container) input:where(.swal2-file):hover,div:where(.swal2-container) textarea:where(.swal2-textarea):hover{box-shadow:var(--swal2-input-hover-box-shadow)}div:where(.swal2-container) input:where(.swal2-input):focus,div:where(.swal2-container) input:where(.swal2-file):focus,div:where(.swal2-container) textarea:where(.swal2-textarea):focus{border:var(--swal2-input-focus-border);outline:none;box-shadow:var(--swal2-input-focus-box-shadow)}div:where(.swal2-container) input:where(.swal2-input)::placeholder,div:where(.swal2-container) input:where(.swal2-file)::placeholder,div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder{color:#ccc}div:where(.swal2-container) .swal2-range{margin:1em 2em 3px;background:var(--swal2-background)}div:where(.swal2-container) .swal2-range input{width:80%}div:where(.swal2-container) .swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}div:where(.swal2-container) .swal2-range input,div:where(.swal2-container) .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}div:where(.swal2-container) .swal2-input{height:2.625em;padding:0 .75em}div:where(.swal2-container) .swal2-file{width:75%;margin-right:auto;margin-left:auto;background:var(--swal2-input-background);font-size:1.125em}div:where(.swal2-container) .swal2-textarea{height:6.75em;padding:.75em}div:where(.swal2-container) .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:var(--swal2-input-background);color:inherit;font-size:1.125em}div:where(.swal2-container) .swal2-radio,div:where(.swal2-container) .swal2-checkbox{align-items:center;justify-content:center;background:var(--swal2-background);color:inherit}div:where(.swal2-container) .swal2-radio label,div:where(.swal2-container) .swal2-checkbox label{margin:0 .6em;font-size:1.125em}div:where(.swal2-container) .swal2-radio input,div:where(.swal2-container) .swal2-checkbox input{flex-shrink:0;margin:0 .4em}div:where(.swal2-container) label:where(.swal2-input-label){display:flex;justify-content:center;margin:1em auto 0}div:where(.swal2-container) div:where(.swal2-validation-message){align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:var(--swal2-validation-message-background);color:var(--swal2-validation-message-color);font-size:1em;font-weight:300}div:where(.swal2-container) div:where(.swal2-validation-message)::before{content:"!";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}div:where(.swal2-container) .swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}div:where(.swal2-container) .swal2-progress-steps li{display:inline-block;position:relative}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:var(--swal2-progress-step-background);color:#fff}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:var(--swal2-progress-step-background)}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}div:where(.swal2-icon){position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;zoom:var(--swal2-icon-zoom);border:.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}div:where(.swal2-icon) .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}div:where(.swal2-icon).swal2-error{border-color:#f27474;color:#f27474}div:where(.swal2-icon).swal2-error .swal2-x-mark{position:relative;flex-grow:1}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}}div:where(.swal2-icon).swal2-warning{border-color:#f8bb86;color:#f8bb86}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}}div:where(.swal2-icon).swal2-info{border-color:#3fc3ee;color:#3fc3ee}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}}div:where(.swal2-icon).swal2-question{border-color:#87adbd;color:#87adbd}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}}div:where(.swal2-icon).swal2-success{border-color:#a5dc86;color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;border-radius:50%}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}div:where(.swal2-icon).swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}div:where(.swal2-icon).swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:var(--swal2-show-animation)}.swal2-hide{animation:var(--swal2-hide-animation)}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;border:var(--swal2-toast-border);background:var(--swal2-background);box-shadow:var(--swal2-toast-box-shadow);pointer-events:all}.swal2-toast>*{grid-column:2}.swal2-toast h2:where(.swal2-title){margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-toast .swal2-loading{justify-content:center}.swal2-toast input:where(.swal2-input){height:2em;margin:.5em;font-size:1em}.swal2-toast .swal2-validation-message{font-size:1em}.swal2-toast div:where(.swal2-footer){margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-toast button:where(.swal2-close){grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-toast div:where(.swal2-html-container){margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-toast div:where(.swal2-html-container):empty{padding:0}.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-toast div:where(.swal2-actions){justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-toast button:where(.swal2-styled){margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;border-radius:50%}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}@container swal2-popup style(--swal2-icon-animations:true){.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}}.swal2-toast.swal2-show{animation:var(--swal2-toast-show-animation)}.swal2-toast.swal2-hide{animation:var(--swal2-toast-hide-animation)}@keyframes swal2-show{0%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}100%{transform:translate3d(0, 0, 0) scale(1);opacity:1}}@keyframes swal2-hide{0%{transform:translate3d(0, 0, 0) scale(1);opacity:1}100%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}');
let Oe = !1;
const Ur = {
  /**
   * Call this once in your main app (e.g., main.ts)
   */
  init(e) {
    Oe = e === !0 || e === "true";
  },
  log: (...e) => {
    Oe && console.log(...e);
  },
  warn: (...e) => {
    Oe && console.warn(...e);
  },
  error: (...e) => {
    Oe && console.error("[DEBUG MODE]", ...e);
  },
  // Helper to check current state
  getStatus: () => Oe
};
function Fr(e) {
  const t = De([]), o = ct({
    currentPage: 0,
    totalPages: 0,
    totalElements: 0
  }), n = De(!1), s = De(null), a = async (k = 0, S = 5) => {
    n.value = !0, s.value = null;
    try {
      const $ = await e.fetchPosts(k, S);
      t.value = $.content, o.currentPage = $.page_number, o.totalPages = $.totalPages, o.totalElements = $.total_elements;
    } catch ($) {
      s.value = $.message || "無法載入文章列表";
    } finally {
      n.value = !1;
    }
  };
  return {
    blogPosts: t,
    pagination: o,
    isBlogLoading: n,
    blogError: s,
    loadBlogPosts: a,
    removePost: async (k) => {
      try {
        await e.deletePost(k), t.value = t.value.filter((S) => S.id !== k);
      } catch {
        s.value = "刪除失敗";
      }
    },
    addPost: async (k, S) => {
      n.value = !0;
      try {
        const $ = await e.createPost(k, S);
        return t.value = [$, ...t.value], $;
      } catch ($) {
        throw s.value = "建立文章失敗", $;
      } finally {
        n.value = !1;
      }
    },
    submitComment: async (k, S) => {
      try {
        Ur.log("Submitting comment for postId:", k, "with content:", S), await e.addComment(k, S), await a(o.currentPage);
      } catch ($) {
        throw s.value = "留言失敗", $;
      }
    }
  };
}
const Rr = { class: "max-w-4xl mx-auto p-6 bg-slate-100 min-h-screen" }, Wr = { class: "mb-8 flex justify-between items-center" }, Zr = {
  key: 0,
  class: "bg-white rounded-xl shadow-sm border border-slate-100 p-6 mb-8 transition-all"
}, Kr = { class: "space-y-4" }, Xr = { class: "flex justify-end" }, Jr = ["disabled"], Qr = {
  key: 1,
  class: "flex justify-center py-10"
}, Gr = {
  key: 2,
  class: "bg-blue-100 border-l-4 border-blue-700 text-blue-700 p-4 mb-6"
}, ea = {
  key: 3,
  class: "space-y-6"
}, ta = { class: "flex justify-between items-start mb-2" }, oa = { class: "text-xl font-bold text-slate-700" }, na = { class: "text-xs bg-slate-100 text-slate-700 px-2 py-1 rounded" }, sa = { class: "text-slate-700 text-xs mb-4 opacity-70" }, ra = { class: "text-slate-700 mb-6 leading-relaxed whitespace-pre-wrap" }, aa = { class: "bg-slate-100 rounded-lg p-4" }, ia = { class: "text-sm font-semibold text-slate-700 mb-3 uppercase tracking-wider" }, la = {
  key: 0,
  class: "mb-4 flex gap-2"
}, ca = ["onUpdate:modelValue", "onKeyup"], ua = ["onClick", "disabled"], da = { class: "text-slate-700 text-sm" }, wa = { class: "mt-1 text-xs text-slate-700 opacity-50" }, ma = { class: "flex justify-center items-center gap-4 mt-8" }, ha = ["disabled"], pa = { class: "text-sm font-medium text-slate-700" }, ga = ["disabled"], fa = {
  key: 4,
  class: "text-center py-20 text-slate-700"
}, va = /* @__PURE__ */ Fo({
  __name: "BlogPostPage",
  props: {
    blogPostApi: {}
  },
  setup(e) {
    De(JSON.parse(localStorage.getItem("roles") || "[]"));
    const t = ["ROLE_ADMIN"];
    Tt(() => JSON.parse(localStorage.getItem("roles") || "[]").some((g) => t.includes(g)));
    const o = () => {
      try {
        return JSON.parse(localStorage.getItem("userRoles") || "[]");
      } catch {
        return [];
      }
    }, n = (...M) => {
      const g = o();
      return M.some((x) => g.includes(x));
    }, s = Tt(() => n("ROLE_ADMIN")), a = e, {
      blogPosts: w,
      pagination: m,
      isBlogLoading: u,
      blogError: k,
      loadBlogPosts: S,
      addPost: $,
      submitComment: T
    } = Fr(a.blogPostApi), A = De(!1), b = ct({
      title: "",
      content: ""
    }), d = ct({}), E = async () => {
      try {
        await $(b.title, b.content), b.title = "", b.content = "", A.value = !1;
      } catch {
      }
    }, H = async (M) => {
      const g = d[M];
      if (g)
        try {
          await T(M, g), d[M] = "";
        } catch {
        }
    };
    return Ro(() => {
      S();
    }), (M, g) => (ie(), ae("div", Rr, [
      B("header", Wr, [
        g[5] || (g[5] = Wo('<div class="mb-6"><h1 class="text-3xl font-extrabold text-slate-700 mb-2"> 留言板 </h1><p class="text-slate-700"> 任何意見都可以留言（大家都看得到） </p><p class="text-slate-700"> 或寄信到 <a href="mailto:contact@bloomingrice.com" class="text-orange-700 hover:underline"> contact@bloomingrice.com </a> （我們的團隊會看到） </p></div>', 1)),
        B("button", {
          onClick: g[0] || (g[0] = (x) => A.value = !A.value),
          class: "bg-orange-700 text-white px-4 py-2 rounded-lg hover:bg-orange-700 transition shadow-md"
        }, ne(A.value ? "取消發布" : "發布新文章"), 1)
      ]),
      A.value ? (ie(), ae("div", Zr, [
        g[8] || (g[8] = B("h2", { class: "text-xl font-bold text-orange-700 mb-4" }, "撰寫新文章", -1)),
        B("div", Kr, [
          B("div", null, [
            g[6] || (g[6] = B("label", { class: "block text-sm font-medium text-slate-700 mb-1" }, "標題", -1)),
            st(B("input", {
              "onUpdate:modelValue": g[1] || (g[1] = (x) => b.title = x),
              type: "text",
              class: "w-full border border-slate-100 rounded-lg px-4 py-2 focus:ring-2 focus:ring-orange-700 outline-none",
              placeholder: "請輸入文章標題..."
            }, null, 512), [
              [rt, b.title]
            ])
          ]),
          B("div", null, [
            g[7] || (g[7] = B("label", { class: "block text-sm font-medium text-slate-700 mb-1" }, "內容", -1)),
            st(B("textarea", {
              "onUpdate:modelValue": g[2] || (g[2] = (x) => b.content = x),
              rows: "4",
              class: "w-full border border-slate-100 rounded-lg px-4 py-2 focus:ring-2 focus:ring-orange-700 outline-none",
              placeholder: "請輸入文章內容..."
            }, null, 512), [
              [rt, b.content]
            ])
          ]),
          B("div", Xr, [
            B("button", {
              onClick: E,
              disabled: !b.title || !b.content || Y(u),
              class: "bg-orange-700 text-white px-6 py-2 rounded-lg hover:bg-orange-700 disabled:opacity-50 transition"
            }, ne(Y(u) ? "發布中..." : "確認發布"), 9, Jr)
          ])
        ])
      ])) : Te("", !0),
      Y(u) && Y(w).length === 0 ? (ie(), ae("div", Qr, [...g[9] || (g[9] = [
        B("span", { class: "animate-pulse text-orange-700 font-bold" }, "載入文章中...", -1)
      ])])) : Te("", !0),
      Y(k) ? (ie(), ae("div", Gr, ne(Y(k)), 1)) : Te("", !0),
      Y(w).length > 0 ? (ie(), ae("div", ea, [
        (ie(!0), ae(Ot, null, Dt(Y(w), (x) => {
          var z;
          return ie(), ae("article", {
            key: x.id,
            class: "bg-white rounded-xl shadow-sm border border-slate-100 p-6"
          }, [
            B("div", ta, [
              B("h2", oa, ne(x.title), 1),
              B("span", na, "ID: " + ne(x.id.slice(0, 8)), 1)
            ]),
            B("p", sa, " 最後更新：" + ne(new Date(x.updated_at).toLocaleString("zh-TW")), 1),
            B("p", ra, ne(x.content), 1),
            B("div", aa, [
              B("h3", ia, " 留言 (" + ne(((z = x.comments) == null ? void 0 : z.length) || 0) + ") ", 1),
              s.value ? (ie(), ae("div", la, [
                st(B("input", {
                  "onUpdate:modelValue": (j) => d[x.id] = j,
                  type: "text",
                  class: "flex-1 border border-slate-100 rounded-lg px-3 py-1 text-sm focus:ring-2 focus:ring-orange-700 outline-none",
                  placeholder: "寫下你的留言...",
                  onKeyup: Zo((j) => H(x.id), ["enter"])
                }, null, 40, ca), [
                  [rt, d[x.id]]
                ]),
                B("button", {
                  onClick: (j) => H(x.id),
                  disabled: !d[x.id],
                  class: "bg-orange-700 text-white px-3 py-1 rounded-lg text-sm hover:bg-orange-700 disabled:opacity-50 transition"
                }, " 傳送 ", 8, ua)
              ])) : Te("", !0),
              (ie(!0), ae(Ot, null, Dt(x.comments, (j) => (ie(), ae("div", {
                key: j.id,
                class: "border-t border-white py-3 first:border-t-0"
              }, [
                B("p", da, ne(j.content), 1),
                B("div", wa, ne(new Date(j.created_at).toLocaleDateString()), 1)
              ]))), 128))
            ])
          ]);
        }), 128)),
        B("nav", ma, [
          B("button", {
            disabled: Y(m).currentPage === 0,
            onClick: g[3] || (g[3] = (x) => Y(S)(Y(m).currentPage - 1)),
            class: "px-4 py-2 border border-slate-100 rounded bg-white text-slate-700 disabled:opacity-30 hover:bg-slate-100 transition"
          }, " 上一頁 ", 8, ha),
          B("span", pa, "第 " + ne(Y(m).currentPage + 1) + " 頁 / 共 " + ne(Y(m).totalPages) + " 頁", 1),
          B("button", {
            disabled: Y(m).currentPage + 1 >= Y(m).totalPages,
            onClick: g[4] || (g[4] = (x) => Y(S)(Y(m).currentPage + 1)),
            class: "px-4 py-2 border border-slate-100 rounded bg-white text-slate-700 disabled:opacity-30 hover:bg-slate-100 transition"
          }, " 下一頁 ", 8, ga)
        ])
      ])) : Y(u) ? Te("", !0) : (ie(), ae("div", fa, " 目前尚無公告文章 "))
    ]));
  }
});
export {
  va as BlogPostPage
};
